import { ApolloClient } from '@apollo/client'
import { useApolloClient, useMutation, useQuery, useSuspenseQuery } from '@apollo/client/react'

import {
  AgreeToServiceTermsDocument,
  AgreeToServiceTermsMutation,
  AgreeToServiceTermsMutationVariables,
  ArchiveAdminIdentityDocument,
  ArchiveAdminIdentityMutation,
  ArchiveAdminIdentityMutationVariables,
  ConfirmMillsheetDuplicateGroupDocument,
  ConfirmMillsheetDuplicateGroupMutation,
  ConfirmMillsheetDuplicateGroupMutationVariables,
  ConfirmOrderDocument,
  ConfirmOrderMutation,
  ConfirmOrderMutationVariables,
  CreateAdminIdentityInvitationDocument,
  CreateAdminIdentityInvitationMutation,
  CreateAdminIdentityInvitationMutationVariables,
  CreateAdminInvitationDocument,
  CreateAdminInvitationMutation,
  CreateAdminInvitationMutationVariables,
  CreateAdminPlanDocument,
  CreateAdminPlanMutation,
  CreateAdminPlanMutationVariables,
  CreateInvitationDocument,
  CreateInvitationMutation,
  CreateInvitationMutationVariables,
  CreateMillsheetsByCsvDocument,
  CreateMillsheetsByCsvMutation,
  CreateMillsheetsByCsvMutationVariables,
  CreateOrderFromPdfDocument,
  CreateOrderFromPdfMutation,
  CreateOrderFromPdfMutationVariables,
  CreateS3ObjectDocument,
  CreateS3ObjectMutation,
  CreateS3ObjectMutationVariables,
  CreateS3ObjectThumbnailsDocument,
  CreateS3ObjectThumbnailsMutation,
  CreateS3ObjectThumbnailsMutationVariables,
  CreateShearingCertificatesByCsvDocument,
  CreateShearingCertificatesByCsvMutation,
  CreateShearingCertificatesByCsvMutationVariables,
  CreateTenantDocument,
  CreateTenantMutation,
  CreateTenantMutationVariables,
  DeleteAdminPlanDocument,
  DeleteAdminPlanMutation,
  DeleteAdminPlanMutationVariables,
  DeleteAdminShapeNameConversionDocument,
  DeleteAdminShapeNameConversionMutation,
  DeleteAdminShapeNameConversionMutationVariables,
  DeleteAdminUserDocument,
  DeleteAdminUserMutation,
  DeleteAdminUserMutationVariables,
  DeleteMillsheetDocument,
  DeleteMillsheetItemsDocument,
  DeleteMillsheetItemsMutation,
  DeleteMillsheetItemsMutationVariables,
  DeleteMillsheetMutation,
  DeleteMillsheetMutationVariables,
  DeleteNestingDiagramDocument,
  DeleteNestingDiagramMutation,
  DeleteNestingDiagramMutationVariables,
  DeleteOrderLineMatchingOrderDocument,
  DeleteOrderLineMatchingOrderMutation,
  DeleteOrderLineMatchingOrderMutationVariables,
  DeleteS3ObjectDocument,
  DeleteS3ObjectMutation,
  DeleteS3ObjectMutationVariables,
  DeleteShearingCertificateDocument,
  DeleteShearingCertificateMutation,
  DeleteShearingCertificateMutationVariables,
  DeleteSteelOrdersByTargetDocument,
  DeleteSteelOrdersByTargetMutation,
  DeleteSteelOrdersByTargetMutationVariables,
  DeleteSteelOrdersDocument,
  DeleteSteelOrdersMutation,
  DeleteSteelOrdersMutationVariables,
  DeleteTenantDocument,
  DeleteTenantMutation,
  DeleteTenantMutationVariables,
  DeleteUserDocument,
  DeleteUserMutation,
  DeleteUserMutationVariables,
  DetachShearingCertificatePdfDocument,
  DetachShearingCertificatePdfMutation,
  DetachShearingCertificatePdfMutationVariables,
  FetchAdminPlansDocument,
  FetchAdminPlansQuery,
  FetchAdminPlansQueryVariables,
  FetchAdminS3ObjectDocument,
  FetchAdminS3ObjectQuery,
  FetchAdminS3ObjectQueryVariables,
  FetchAdminShapeNameConversionsDocument,
  FetchAdminShapeNameConversionsQuery,
  FetchAdminShapeNameConversionsQueryVariables,
  FetchAdminTenantsDocument,
  FetchAdminTenantsQuery,
  FetchAdminTenantsQueryVariables,
  FetchDashboardDocument,
  FetchDashboardQuery,
  FetchDashboardQueryVariables,
  FetchMeDocument,
  FetchMeQuery,
  FetchMeQueryVariables,
  FetchMillsheetDuplicateGroupCountDocument,
  FetchMillsheetDuplicateGroupCountQuery,
  FetchMillsheetDuplicateGroupCountQueryVariables,
  FetchMillsheetDuplicateGroupsDocument,
  FetchMillsheetDuplicateGroupsQuery,
  FetchMillsheetDuplicateGroupsQueryVariables,
  FetchMillsheetItemsDocument,
  FetchMillsheetItemsQuery,
  FetchMillsheetItemsQueryVariables,
  FetchMillsheetUniqueValuesDocument,
  FetchMillsheetUniqueValuesQuery,
  FetchMillsheetUniqueValuesQueryVariables,
  FetchMillsheetsDocument,
  FetchMillsheetsFilterOptionsDocument,
  FetchMillsheetsFilterOptionsQuery,
  FetchMillsheetsFilterOptionsQueryVariables,
  FetchMillsheetsQuery,
  FetchMillsheetsQueryVariables,
  FetchMyIdentityDocument,
  FetchMyIdentityQuery,
  FetchMyIdentityQueryVariables,
  FetchMyTenantDetailDocument,
  FetchMyTenantDetailQuery,
  FetchMyTenantDetailQueryVariables,
  FetchNestingDiagramsDocument,
  FetchNestingDiagramsQuery,
  FetchNestingDiagramsQueryVariables,
  FetchOrderDocument,
  FetchOrderLineMatchingPdfUrlDocument,
  FetchOrderLineMatchingPdfUrlQuery,
  FetchOrderLineMatchingPdfUrlQueryVariables,
  FetchOrderLineMatchingProjectDocument,
  FetchOrderLineMatchingProjectQuery,
  FetchOrderLineMatchingProjectQueryVariables,
  FetchOrderLineMatchingProjectsDocument,
  FetchOrderLineMatchingProjectsQuery,
  FetchOrderLineMatchingProjectsQueryVariables,
  FetchOrderLineMatchingUnlinkedFilterOptionsDocument,
  FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
  FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables,
  FetchOrderLineMatchingUnlinkedItemsDocument,
  FetchOrderLineMatchingUnlinkedItemsQuery,
  FetchOrderLineMatchingUnlinkedItemsQueryVariables,
  FetchOrderOcrEnabledDocument,
  FetchOrderOcrEnabledQuery,
  FetchOrderOcrEnabledQueryVariables,
  FetchOrderPdfUrlDocument,
  FetchOrderPdfUrlQuery,
  FetchOrderPdfUrlQueryVariables,
  FetchOrderProjectNamesDocument,
  FetchOrderProjectNamesQuery,
  FetchOrderProjectNamesQueryVariables,
  FetchOrderQuery,
  FetchOrderQueryVariables,
  FetchOrdersDocument,
  FetchOrdersQuery,
  FetchOrdersQueryVariables,
  FetchPagedAdminIdentitiesDocument,
  FetchPagedAdminIdentitiesQuery,
  FetchPagedAdminIdentitiesQueryVariables,
  FetchPagedMillsheetItemsDocument,
  FetchPagedMillsheetItemsQuery,
  FetchPagedMillsheetItemsQueryVariables,
  FetchPagedMillsheetsDocument,
  FetchPagedMillsheetsQuery,
  FetchPagedMillsheetsQueryVariables,
  FetchPagedNestingDiagramsDocument,
  FetchPagedNestingDiagramsQuery,
  FetchPagedNestingDiagramsQueryVariables,
  FetchPagedS3ObjectsDocument,
  FetchPagedS3ObjectsQuery,
  FetchPagedS3ObjectsQueryVariables,
  FetchPagedShearingCertificatePdfsDocument,
  FetchPagedShearingCertificatePdfsQuery,
  FetchPagedShearingCertificatePdfsQueryVariables,
  FetchPagedShearingCertificatesDocument,
  FetchPagedShearingCertificatesQuery,
  FetchPagedShearingCertificatesQueryVariables,
  FetchPagedSteelOrderCsvImportsDocument,
  FetchPagedSteelOrderCsvImportsQuery,
  FetchPagedSteelOrderCsvImportsQueryVariables,
  FetchPagedUnlinkedMillsheetsDocument,
  FetchPagedUnlinkedMillsheetsQuery,
  FetchPagedUnlinkedMillsheetsQueryVariables,
  FetchS3ObjectsDocument,
  FetchS3ObjectsQuery,
  FetchS3ObjectsQueryVariables,
  FetchShapeNameConversionsDocument,
  FetchShapeNameConversionsQuery,
  FetchShapeNameConversionsQueryVariables,
  FetchShearingCertificatePdfsDocument,
  FetchShearingCertificatePdfsQuery,
  FetchShearingCertificatePdfsQueryVariables,
  FetchShearingCertificateUniqueValuesDocument,
  FetchShearingCertificateUniqueValuesQuery,
  FetchShearingCertificateUniqueValuesQueryVariables,
  FetchShearingCertificatesDocument,
  FetchShearingCertificatesFilterOptionsDocument,
  FetchShearingCertificatesFilterOptionsQuery,
  FetchShearingCertificatesFilterOptionsQueryVariables,
  FetchShearingCertificatesQuery,
  FetchShearingCertificatesQueryVariables,
  FetchSteelOrderCsvImportsDocument,
  FetchSteelOrderCsvImportsQuery,
  FetchSteelOrderCsvImportsQueryVariables,
  FetchSteelOrderDetailDocument,
  FetchSteelOrderDetailQuery,
  FetchSteelOrderDetailQueryVariables,
  FetchSteelOrdersDocument,
  FetchSteelOrdersForPrintDocument,
  FetchSteelOrdersForPrintQuery,
  FetchSteelOrdersForPrintQueryVariables,
  FetchSteelOrdersQuery,
  FetchSteelOrdersQueryVariables,
  FetchTenantDocument,
  FetchTenantQuery,
  FetchTenantQueryVariables,
  FetchTenantsDocument,
  FetchTenantsQuery,
  FetchTenantsQueryVariables,
  FetchUnlinkedMillsheetsDocument,
  FetchUnlinkedMillsheetsFilterOptionsDocument,
  FetchUnlinkedMillsheetsFilterOptionsQuery,
  FetchUnlinkedMillsheetsFilterOptionsQueryVariables,
  FetchUnlinkedMillsheetsQuery,
  FetchUnlinkedMillsheetsQueryVariables,
  FetchUsersDocument,
  FetchUsersQuery,
  FetchUsersQueryVariables,
  ImportAdminOrderCsvDocument,
  ImportAdminOrderCsvMutation,
  ImportAdminOrderCsvMutationVariables,
  ImportDeliveryTableCsvDocument,
  ImportDeliveryTableCsvMutation,
  ImportDeliveryTableCsvMutationVariables,
  ImportScrmCsvDocument,
  ImportScrmCsvMutation,
  ImportScrmCsvMutationVariables,
  PrepareAdminOrderPdfUploadDocument,
  PrepareAdminOrderPdfUploadMutation,
  PrepareAdminOrderPdfUploadMutationVariables,
  PrepareOrderPdfUploadDocument,
  PrepareOrderPdfUploadMutation,
  PrepareOrderPdfUploadMutationVariables,
  PreviewAdminOrderCsvDocument,
  PreviewAdminOrderCsvMutation,
  PreviewAdminOrderCsvMutationVariables,
  ReleaseOrderLineMatchingAllocationDocument,
  ReleaseOrderLineMatchingAllocationMutation,
  ReleaseOrderLineMatchingAllocationMutationVariables,
  RenameOrderProjectDocument,
  RenameOrderProjectMutation,
  RenameOrderProjectMutationVariables,
  RestoreAdminIdentityDocument,
  RestoreAdminIdentityMutation,
  RestoreAdminIdentityMutationVariables,
  RetryOrderOcrDocument,
  RetryOrderOcrMutation,
  RetryOrderOcrMutationVariables,
  UnconfirmMillsheetDuplicateGroupDocument,
  UnconfirmMillsheetDuplicateGroupMutation,
  UnconfirmMillsheetDuplicateGroupMutationVariables,
  UnlinkMillsheetS3ObjectsDocument,
  UnlinkMillsheetS3ObjectsMutation,
  UnlinkMillsheetS3ObjectsMutationVariables,
  UpdateAdminIdentityRoleDocument,
  UpdateAdminIdentityRoleMutation,
  UpdateAdminIdentityRoleMutationVariables,
  UpdateAdminPlanDocument,
  UpdateAdminPlanMutation,
  UpdateAdminPlanMutationVariables,
  UpdateMillsheetDocument,
  UpdateMillsheetItemDocument,
  UpdateMillsheetItemMutation,
  UpdateMillsheetItemMutationVariables,
  UpdateMillsheetMutation,
  UpdateMillsheetMutationVariables,
  UpdateMillsheetOrderNumberDocument,
  UpdateMillsheetOrderNumberMutation,
  UpdateMillsheetOrderNumberMutationVariables,
  UpdateMillsheetsDocument,
  UpdateMillsheetsMutation,
  UpdateMillsheetsMutationVariables,
  UpdateNestingDiagramDocument,
  UpdateNestingDiagramMutation,
  UpdateNestingDiagramMutationVariables,
  UpdateOrderFromReviewDocument,
  UpdateOrderFromReviewMutation,
  UpdateOrderFromReviewMutationVariables,
  UpdateOrderLineMatchingItemDocument,
  UpdateOrderLineMatchingItemMutation,
  UpdateOrderLineMatchingItemMutationVariables,
  UpdateS3ObjectDocument,
  UpdateS3ObjectMutation,
  UpdateS3ObjectMutationVariables,
  UpdateSteelOrderItemQualityCheckStatusDocument,
  UpdateSteelOrderItemQualityCheckStatusMutation,
  UpdateSteelOrderItemQualityCheckStatusMutationVariables,
  UpdateSteelOrdersDocument,
  UpdateSteelOrdersMutation,
  UpdateSteelOrdersMutationVariables,
  UpdateTenantDocument,
  UpdateTenantMutation,
  UpdateTenantMutationVariables,
  UpdateTenantSettingDocument,
  UpdateTenantSettingMutation,
  UpdateTenantSettingMutationVariables,
  UpdateUserDocument,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UpsertAdminShapeNameConversionDocument,
  UpsertAdminShapeNameConversionMutation,
  UpsertAdminShapeNameConversionMutationVariables,
  UpsertAdminTenantSettingDocument,
  UpsertAdminTenantSettingMutation,
  UpsertAdminTenantSettingMutationVariables,
  UpsertOrderLineMatchingAllocationDocument,
  UpsertOrderLineMatchingAllocationMutation,
  UpsertOrderLineMatchingAllocationMutationVariables,
} from './apollo'

export function useFetchAdminS3ObjectQuery(
  baseOptions: useQuery.Options<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>,
) {
  return useQuery<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>(FetchAdminS3ObjectDocument, baseOptions)
}

export function useFetchAdminS3ObjectSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchAdminS3ObjectQueryVariables>,
) {
  return useSuspenseQuery<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>(
    FetchAdminS3ObjectDocument,
    baseOptions,
  )
}

export function useFetchAdminShapeNameConversionsQuery(
  baseOptions: useQuery.Options<FetchAdminShapeNameConversionsQuery, FetchAdminShapeNameConversionsQueryVariables>,
) {
  return useQuery<FetchAdminShapeNameConversionsQuery, FetchAdminShapeNameConversionsQueryVariables>(
    FetchAdminShapeNameConversionsDocument,
    baseOptions,
  )
}

export function useFetchAdminShapeNameConversionsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchAdminShapeNameConversionsQueryVariables>,
) {
  return useSuspenseQuery<FetchAdminShapeNameConversionsQuery, FetchAdminShapeNameConversionsQueryVariables>(
    FetchAdminShapeNameConversionsDocument,
    baseOptions,
  )
}

export function useFetchAdminTenantsQuery(
  baseOptions?: useQuery.Options<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>,
) {
  return useQuery<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>(FetchAdminTenantsDocument, baseOptions)
}

export function useFetchAdminTenantsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchAdminTenantsQueryVariables>,
) {
  return useSuspenseQuery<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>(
    FetchAdminTenantsDocument,
    baseOptions,
  )
}

export function useFetchDashboardQuery(
  baseOptions?: useQuery.Options<FetchDashboardQuery, FetchDashboardQueryVariables>,
) {
  return useQuery<FetchDashboardQuery, FetchDashboardQueryVariables>(FetchDashboardDocument, baseOptions)
}

export function useFetchDashboardSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchDashboardQueryVariables>) {
  return useSuspenseQuery<FetchDashboardQuery, FetchDashboardQueryVariables>(FetchDashboardDocument, baseOptions)
}

export function useFetchMeQuery(baseOptions?: useQuery.Options<FetchMeQuery, FetchMeQueryVariables>) {
  return useQuery<FetchMeQuery, FetchMeQueryVariables>(FetchMeDocument, baseOptions)
}

export function useFetchMeSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchMeQueryVariables>) {
  return useSuspenseQuery<FetchMeQuery, FetchMeQueryVariables>(FetchMeDocument, baseOptions)
}

export function useFetchMillsheetDuplicateGroupCountQuery(
  baseOptions: useQuery.Options<
    FetchMillsheetDuplicateGroupCountQuery,
    FetchMillsheetDuplicateGroupCountQueryVariables
  >,
) {
  return useQuery<FetchMillsheetDuplicateGroupCountQuery, FetchMillsheetDuplicateGroupCountQueryVariables>(
    FetchMillsheetDuplicateGroupCountDocument,
    baseOptions,
  )
}

export function useFetchMillsheetDuplicateGroupCountSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchMillsheetDuplicateGroupCountQueryVariables>,
) {
  return useSuspenseQuery<FetchMillsheetDuplicateGroupCountQuery, FetchMillsheetDuplicateGroupCountQueryVariables>(
    FetchMillsheetDuplicateGroupCountDocument,
    baseOptions,
  )
}

export function useFetchMillsheetDuplicateGroupsQuery(
  baseOptions: useQuery.Options<FetchMillsheetDuplicateGroupsQuery, FetchMillsheetDuplicateGroupsQueryVariables>,
) {
  return useQuery<FetchMillsheetDuplicateGroupsQuery, FetchMillsheetDuplicateGroupsQueryVariables>(
    FetchMillsheetDuplicateGroupsDocument,
    baseOptions,
  )
}

export function useFetchMillsheetDuplicateGroupsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchMillsheetDuplicateGroupsQueryVariables>,
) {
  return useSuspenseQuery<FetchMillsheetDuplicateGroupsQuery, FetchMillsheetDuplicateGroupsQueryVariables>(
    FetchMillsheetDuplicateGroupsDocument,
    baseOptions,
  )
}

export function useFetchMillsheetItemsQuery(
  baseOptions: useQuery.Options<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>,
) {
  return useQuery<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>(FetchMillsheetItemsDocument, baseOptions)
}

export function useFetchMillsheetItemsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchMillsheetItemsQueryVariables>,
) {
  return useSuspenseQuery<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>(
    FetchMillsheetItemsDocument,
    baseOptions,
  )
}

export function useFetchMillsheetUniqueValuesQuery(
  baseOptions?: useQuery.Options<FetchMillsheetUniqueValuesQuery, FetchMillsheetUniqueValuesQueryVariables>,
) {
  return useQuery<FetchMillsheetUniqueValuesQuery, FetchMillsheetUniqueValuesQueryVariables>(
    FetchMillsheetUniqueValuesDocument,
    baseOptions,
  )
}

export function useFetchMillsheetUniqueValuesSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchMillsheetUniqueValuesQueryVariables>,
) {
  return useSuspenseQuery<FetchMillsheetUniqueValuesQuery, FetchMillsheetUniqueValuesQueryVariables>(
    FetchMillsheetUniqueValuesDocument,
    baseOptions,
  )
}

export function useFetchMillsheetsQuery(
  baseOptions?: useQuery.Options<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>,
) {
  return useQuery<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>(FetchMillsheetsDocument, baseOptions)
}

export function useFetchMillsheetsSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchMillsheetsQueryVariables>) {
  return useSuspenseQuery<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>(FetchMillsheetsDocument, baseOptions)
}

export function useFetchMillsheetsFilterOptionsQuery(
  baseOptions?: useQuery.Options<FetchMillsheetsFilterOptionsQuery, FetchMillsheetsFilterOptionsQueryVariables>,
) {
  return useQuery<FetchMillsheetsFilterOptionsQuery, FetchMillsheetsFilterOptionsQueryVariables>(
    FetchMillsheetsFilterOptionsDocument,
    baseOptions,
  )
}

export function useFetchMillsheetsFilterOptionsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchMillsheetsFilterOptionsQueryVariables>,
) {
  return useSuspenseQuery<FetchMillsheetsFilterOptionsQuery, FetchMillsheetsFilterOptionsQueryVariables>(
    FetchMillsheetsFilterOptionsDocument,
    baseOptions,
  )
}

export function useFetchMyIdentityQuery(
  baseOptions?: useQuery.Options<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>,
) {
  return useQuery<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>(FetchMyIdentityDocument, baseOptions)
}

export function useFetchMyIdentitySuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchMyIdentityQueryVariables>) {
  return useSuspenseQuery<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>(FetchMyIdentityDocument, baseOptions)
}

export function useFetchMyTenantDetailQuery(
  baseOptions?: useQuery.Options<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>,
) {
  return useQuery<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>(FetchMyTenantDetailDocument, baseOptions)
}

export function useFetchMyTenantDetailSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchMyTenantDetailQueryVariables>,
) {
  return useSuspenseQuery<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>(
    FetchMyTenantDetailDocument,
    baseOptions,
  )
}

export function useFetchNestingDiagramsQuery(
  baseOptions?: useQuery.Options<FetchNestingDiagramsQuery, FetchNestingDiagramsQueryVariables>,
) {
  return useQuery<FetchNestingDiagramsQuery, FetchNestingDiagramsQueryVariables>(
    FetchNestingDiagramsDocument,
    baseOptions,
  )
}

export function useFetchNestingDiagramsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchNestingDiagramsQueryVariables>,
) {
  return useSuspenseQuery<FetchNestingDiagramsQuery, FetchNestingDiagramsQueryVariables>(
    FetchNestingDiagramsDocument,
    baseOptions,
  )
}

export function useFetchOrderQuery(baseOptions: useQuery.Options<FetchOrderQuery, FetchOrderQueryVariables>) {
  return useQuery<FetchOrderQuery, FetchOrderQueryVariables>(FetchOrderDocument, baseOptions)
}

export function useFetchOrderSuspenseQuery(baseOptions: useSuspenseQuery.Options<FetchOrderQueryVariables>) {
  return useSuspenseQuery<FetchOrderQuery, FetchOrderQueryVariables>(FetchOrderDocument, baseOptions)
}

export function useFetchOrderLineMatchingPdfUrlQuery(
  baseOptions: useQuery.Options<FetchOrderLineMatchingPdfUrlQuery, FetchOrderLineMatchingPdfUrlQueryVariables>,
) {
  return useQuery<FetchOrderLineMatchingPdfUrlQuery, FetchOrderLineMatchingPdfUrlQueryVariables>(
    FetchOrderLineMatchingPdfUrlDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingPdfUrlSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchOrderLineMatchingPdfUrlQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderLineMatchingPdfUrlQuery, FetchOrderLineMatchingPdfUrlQueryVariables>(
    FetchOrderLineMatchingPdfUrlDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingProjectQuery(
  baseOptions: useQuery.Options<FetchOrderLineMatchingProjectQuery, FetchOrderLineMatchingProjectQueryVariables>,
) {
  return useQuery<FetchOrderLineMatchingProjectQuery, FetchOrderLineMatchingProjectQueryVariables>(
    FetchOrderLineMatchingProjectDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingProjectSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchOrderLineMatchingProjectQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderLineMatchingProjectQuery, FetchOrderLineMatchingProjectQueryVariables>(
    FetchOrderLineMatchingProjectDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingProjectsQuery(
  baseOptions: useQuery.Options<FetchOrderLineMatchingProjectsQuery, FetchOrderLineMatchingProjectsQueryVariables>,
) {
  return useQuery<FetchOrderLineMatchingProjectsQuery, FetchOrderLineMatchingProjectsQueryVariables>(
    FetchOrderLineMatchingProjectsDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingProjectsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchOrderLineMatchingProjectsQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderLineMatchingProjectsQuery, FetchOrderLineMatchingProjectsQueryVariables>(
    FetchOrderLineMatchingProjectsDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingUnlinkedFilterOptionsQuery(
  baseOptions?: useQuery.Options<
    FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
    FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables
  >,
) {
  return useQuery<
    FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
    FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables
  >(FetchOrderLineMatchingUnlinkedFilterOptionsDocument, baseOptions)
}

export function useFetchOrderLineMatchingUnlinkedFilterOptionsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables>,
) {
  return useSuspenseQuery<
    FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
    FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables
  >(FetchOrderLineMatchingUnlinkedFilterOptionsDocument, baseOptions)
}

export function useFetchOrderLineMatchingUnlinkedItemsQuery(
  baseOptions: useQuery.Options<
    FetchOrderLineMatchingUnlinkedItemsQuery,
    FetchOrderLineMatchingUnlinkedItemsQueryVariables
  >,
) {
  return useQuery<FetchOrderLineMatchingUnlinkedItemsQuery, FetchOrderLineMatchingUnlinkedItemsQueryVariables>(
    FetchOrderLineMatchingUnlinkedItemsDocument,
    baseOptions,
  )
}

export function useFetchOrderLineMatchingUnlinkedItemsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchOrderLineMatchingUnlinkedItemsQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderLineMatchingUnlinkedItemsQuery, FetchOrderLineMatchingUnlinkedItemsQueryVariables>(
    FetchOrderLineMatchingUnlinkedItemsDocument,
    baseOptions,
  )
}

export function useFetchOrderOcrEnabledQuery(
  baseOptions?: useQuery.Options<FetchOrderOcrEnabledQuery, FetchOrderOcrEnabledQueryVariables>,
) {
  return useQuery<FetchOrderOcrEnabledQuery, FetchOrderOcrEnabledQueryVariables>(
    FetchOrderOcrEnabledDocument,
    baseOptions,
  )
}

export function useFetchOrderOcrEnabledSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchOrderOcrEnabledQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderOcrEnabledQuery, FetchOrderOcrEnabledQueryVariables>(
    FetchOrderOcrEnabledDocument,
    baseOptions,
  )
}

export function useFetchOrderPdfUrlQuery(
  baseOptions: useQuery.Options<FetchOrderPdfUrlQuery, FetchOrderPdfUrlQueryVariables>,
) {
  return useQuery<FetchOrderPdfUrlQuery, FetchOrderPdfUrlQueryVariables>(FetchOrderPdfUrlDocument, baseOptions)
}

export function useFetchOrderPdfUrlSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchOrderPdfUrlQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderPdfUrlQuery, FetchOrderPdfUrlQueryVariables>(FetchOrderPdfUrlDocument, baseOptions)
}

export function useFetchOrderProjectNamesQuery(
  baseOptions?: useQuery.Options<FetchOrderProjectNamesQuery, FetchOrderProjectNamesQueryVariables>,
) {
  return useQuery<FetchOrderProjectNamesQuery, FetchOrderProjectNamesQueryVariables>(
    FetchOrderProjectNamesDocument,
    baseOptions,
  )
}

export function useFetchOrderProjectNamesSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchOrderProjectNamesQueryVariables>,
) {
  return useSuspenseQuery<FetchOrderProjectNamesQuery, FetchOrderProjectNamesQueryVariables>(
    FetchOrderProjectNamesDocument,
    baseOptions,
  )
}

export function useFetchOrdersQuery(baseOptions?: useQuery.Options<FetchOrdersQuery, FetchOrdersQueryVariables>) {
  return useQuery<FetchOrdersQuery, FetchOrdersQueryVariables>(FetchOrdersDocument, baseOptions)
}

export function useFetchOrdersSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchOrdersQueryVariables>) {
  return useSuspenseQuery<FetchOrdersQuery, FetchOrdersQueryVariables>(FetchOrdersDocument, baseOptions)
}

export function useFetchPagedAdminIdentitiesQuery(
  baseOptions?: useQuery.Options<FetchPagedAdminIdentitiesQuery, FetchPagedAdminIdentitiesQueryVariables>,
) {
  return useQuery<FetchPagedAdminIdentitiesQuery, FetchPagedAdminIdentitiesQueryVariables>(
    FetchPagedAdminIdentitiesDocument,
    baseOptions,
  )
}

export function useFetchPagedAdminIdentitiesSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchPagedAdminIdentitiesQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedAdminIdentitiesQuery, FetchPagedAdminIdentitiesQueryVariables>(
    FetchPagedAdminIdentitiesDocument,
    baseOptions,
  )
}

export function useFetchPagedMillsheetItemsQuery(
  baseOptions: useQuery.Options<FetchPagedMillsheetItemsQuery, FetchPagedMillsheetItemsQueryVariables>,
) {
  return useQuery<FetchPagedMillsheetItemsQuery, FetchPagedMillsheetItemsQueryVariables>(
    FetchPagedMillsheetItemsDocument,
    baseOptions,
  )
}

export function useFetchPagedMillsheetItemsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchPagedMillsheetItemsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedMillsheetItemsQuery, FetchPagedMillsheetItemsQueryVariables>(
    FetchPagedMillsheetItemsDocument,
    baseOptions,
  )
}

export function useFetchPagedMillsheetsQuery(
  baseOptions: useQuery.Options<FetchPagedMillsheetsQuery, FetchPagedMillsheetsQueryVariables>,
) {
  return useQuery<FetchPagedMillsheetsQuery, FetchPagedMillsheetsQueryVariables>(
    FetchPagedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchPagedMillsheetsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchPagedMillsheetsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedMillsheetsQuery, FetchPagedMillsheetsQueryVariables>(
    FetchPagedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchPagedNestingDiagramsQuery(
  baseOptions?: useQuery.Options<FetchPagedNestingDiagramsQuery, FetchPagedNestingDiagramsQueryVariables>,
) {
  return useQuery<FetchPagedNestingDiagramsQuery, FetchPagedNestingDiagramsQueryVariables>(
    FetchPagedNestingDiagramsDocument,
    baseOptions,
  )
}

export function useFetchPagedNestingDiagramsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchPagedNestingDiagramsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedNestingDiagramsQuery, FetchPagedNestingDiagramsQueryVariables>(
    FetchPagedNestingDiagramsDocument,
    baseOptions,
  )
}

export function useFetchPagedS3ObjectsQuery(
  baseOptions?: useQuery.Options<FetchPagedS3ObjectsQuery, FetchPagedS3ObjectsQueryVariables>,
) {
  return useQuery<FetchPagedS3ObjectsQuery, FetchPagedS3ObjectsQueryVariables>(FetchPagedS3ObjectsDocument, baseOptions)
}

export function useFetchPagedS3ObjectsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchPagedS3ObjectsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedS3ObjectsQuery, FetchPagedS3ObjectsQueryVariables>(
    FetchPagedS3ObjectsDocument,
    baseOptions,
  )
}

export function useFetchPagedShearingCertificatePdfsQuery(
  baseOptions?: useQuery.Options<
    FetchPagedShearingCertificatePdfsQuery,
    FetchPagedShearingCertificatePdfsQueryVariables
  >,
) {
  return useQuery<FetchPagedShearingCertificatePdfsQuery, FetchPagedShearingCertificatePdfsQueryVariables>(
    FetchPagedShearingCertificatePdfsDocument,
    baseOptions,
  )
}

export function useFetchPagedShearingCertificatePdfsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchPagedShearingCertificatePdfsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedShearingCertificatePdfsQuery, FetchPagedShearingCertificatePdfsQueryVariables>(
    FetchPagedShearingCertificatePdfsDocument,
    baseOptions,
  )
}

export function useFetchPagedShearingCertificatesQuery(
  baseOptions: useQuery.Options<FetchPagedShearingCertificatesQuery, FetchPagedShearingCertificatesQueryVariables>,
) {
  return useQuery<FetchPagedShearingCertificatesQuery, FetchPagedShearingCertificatesQueryVariables>(
    FetchPagedShearingCertificatesDocument,
    baseOptions,
  )
}

export function useFetchPagedShearingCertificatesSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchPagedShearingCertificatesQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedShearingCertificatesQuery, FetchPagedShearingCertificatesQueryVariables>(
    FetchPagedShearingCertificatesDocument,
    baseOptions,
  )
}

export function useFetchPagedSteelOrderCsvImportsQuery(
  baseOptions?: useQuery.Options<FetchPagedSteelOrderCsvImportsQuery, FetchPagedSteelOrderCsvImportsQueryVariables>,
) {
  return useQuery<FetchPagedSteelOrderCsvImportsQuery, FetchPagedSteelOrderCsvImportsQueryVariables>(
    FetchPagedSteelOrderCsvImportsDocument,
    baseOptions,
  )
}

export function useFetchPagedSteelOrderCsvImportsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchPagedSteelOrderCsvImportsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedSteelOrderCsvImportsQuery, FetchPagedSteelOrderCsvImportsQueryVariables>(
    FetchPagedSteelOrderCsvImportsDocument,
    baseOptions,
  )
}

export function useFetchPagedUnlinkedMillsheetsQuery(
  baseOptions: useQuery.Options<FetchPagedUnlinkedMillsheetsQuery, FetchPagedUnlinkedMillsheetsQueryVariables>,
) {
  return useQuery<FetchPagedUnlinkedMillsheetsQuery, FetchPagedUnlinkedMillsheetsQueryVariables>(
    FetchPagedUnlinkedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchPagedUnlinkedMillsheetsSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchPagedUnlinkedMillsheetsQueryVariables>,
) {
  return useSuspenseQuery<FetchPagedUnlinkedMillsheetsQuery, FetchPagedUnlinkedMillsheetsQueryVariables>(
    FetchPagedUnlinkedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchAdminPlansQuery(
  baseOptions?: useQuery.Options<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>,
) {
  return useQuery<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>(FetchAdminPlansDocument, baseOptions)
}

export function useFetchAdminPlansSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchAdminPlansQueryVariables>) {
  return useSuspenseQuery<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>(FetchAdminPlansDocument, baseOptions)
}

export function useFetchS3ObjectsQuery(
  baseOptions?: useQuery.Options<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>,
) {
  return useQuery<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>(FetchS3ObjectsDocument, baseOptions)
}

export function useFetchS3ObjectsSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchS3ObjectsQueryVariables>) {
  return useSuspenseQuery<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>(FetchS3ObjectsDocument, baseOptions)
}

export function useFetchShapeNameConversionsQuery(
  baseOptions?: useQuery.Options<FetchShapeNameConversionsQuery, FetchShapeNameConversionsQueryVariables>,
) {
  return useQuery<FetchShapeNameConversionsQuery, FetchShapeNameConversionsQueryVariables>(
    FetchShapeNameConversionsDocument,
    baseOptions,
  )
}

export function useFetchShapeNameConversionsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchShapeNameConversionsQueryVariables>,
) {
  return useSuspenseQuery<FetchShapeNameConversionsQuery, FetchShapeNameConversionsQueryVariables>(
    FetchShapeNameConversionsDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificatePdfsQuery(
  baseOptions?: useQuery.Options<FetchShearingCertificatePdfsQuery, FetchShearingCertificatePdfsQueryVariables>,
) {
  return useQuery<FetchShearingCertificatePdfsQuery, FetchShearingCertificatePdfsQueryVariables>(
    FetchShearingCertificatePdfsDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificatePdfsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchShearingCertificatePdfsQueryVariables>,
) {
  return useSuspenseQuery<FetchShearingCertificatePdfsQuery, FetchShearingCertificatePdfsQueryVariables>(
    FetchShearingCertificatePdfsDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificateUniqueValuesQuery(
  baseOptions?: useQuery.Options<
    FetchShearingCertificateUniqueValuesQuery,
    FetchShearingCertificateUniqueValuesQueryVariables
  >,
) {
  return useQuery<FetchShearingCertificateUniqueValuesQuery, FetchShearingCertificateUniqueValuesQueryVariables>(
    FetchShearingCertificateUniqueValuesDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificateUniqueValuesSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchShearingCertificateUniqueValuesQueryVariables>,
) {
  return useSuspenseQuery<
    FetchShearingCertificateUniqueValuesQuery,
    FetchShearingCertificateUniqueValuesQueryVariables
  >(FetchShearingCertificateUniqueValuesDocument, baseOptions)
}

export function useFetchShearingCertificatesQuery(
  baseOptions?: useQuery.Options<FetchShearingCertificatesQuery, FetchShearingCertificatesQueryVariables>,
) {
  return useQuery<FetchShearingCertificatesQuery, FetchShearingCertificatesQueryVariables>(
    FetchShearingCertificatesDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificatesSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchShearingCertificatesQueryVariables>,
) {
  return useSuspenseQuery<FetchShearingCertificatesQuery, FetchShearingCertificatesQueryVariables>(
    FetchShearingCertificatesDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificatesFilterOptionsQuery(
  baseOptions?: useQuery.Options<
    FetchShearingCertificatesFilterOptionsQuery,
    FetchShearingCertificatesFilterOptionsQueryVariables
  >,
) {
  return useQuery<FetchShearingCertificatesFilterOptionsQuery, FetchShearingCertificatesFilterOptionsQueryVariables>(
    FetchShearingCertificatesFilterOptionsDocument,
    baseOptions,
  )
}

export function useFetchShearingCertificatesFilterOptionsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchShearingCertificatesFilterOptionsQueryVariables>,
) {
  return useSuspenseQuery<
    FetchShearingCertificatesFilterOptionsQuery,
    FetchShearingCertificatesFilterOptionsQueryVariables
  >(FetchShearingCertificatesFilterOptionsDocument, baseOptions)
}

export function useFetchSteelOrderCsvImportsQuery(
  baseOptions?: useQuery.Options<FetchSteelOrderCsvImportsQuery, FetchSteelOrderCsvImportsQueryVariables>,
) {
  return useQuery<FetchSteelOrderCsvImportsQuery, FetchSteelOrderCsvImportsQueryVariables>(
    FetchSteelOrderCsvImportsDocument,
    baseOptions,
  )
}

export function useFetchSteelOrderCsvImportsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchSteelOrderCsvImportsQueryVariables>,
) {
  return useSuspenseQuery<FetchSteelOrderCsvImportsQuery, FetchSteelOrderCsvImportsQueryVariables>(
    FetchSteelOrderCsvImportsDocument,
    baseOptions,
  )
}

export function useFetchSteelOrderDetailQuery(
  baseOptions: useQuery.Options<FetchSteelOrderDetailQuery, FetchSteelOrderDetailQueryVariables>,
) {
  return useQuery<FetchSteelOrderDetailQuery, FetchSteelOrderDetailQueryVariables>(
    FetchSteelOrderDetailDocument,
    baseOptions,
  )
}

export function useFetchSteelOrderDetailSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchSteelOrderDetailQueryVariables>,
) {
  return useSuspenseQuery<FetchSteelOrderDetailQuery, FetchSteelOrderDetailQueryVariables>(
    FetchSteelOrderDetailDocument,
    baseOptions,
  )
}

export function useFetchSteelOrdersQuery(
  baseOptions: useQuery.Options<FetchSteelOrdersQuery, FetchSteelOrdersQueryVariables>,
) {
  return useQuery<FetchSteelOrdersQuery, FetchSteelOrdersQueryVariables>(FetchSteelOrdersDocument, baseOptions)
}

export function useFetchSteelOrdersSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchSteelOrdersQueryVariables>,
) {
  return useSuspenseQuery<FetchSteelOrdersQuery, FetchSteelOrdersQueryVariables>(FetchSteelOrdersDocument, baseOptions)
}

export function useFetchSteelOrdersForPrintQuery(
  baseOptions: useQuery.Options<FetchSteelOrdersForPrintQuery, FetchSteelOrdersForPrintQueryVariables>,
) {
  return useQuery<FetchSteelOrdersForPrintQuery, FetchSteelOrdersForPrintQueryVariables>(
    FetchSteelOrdersForPrintDocument,
    baseOptions,
  )
}

export function useFetchSteelOrdersForPrintSuspenseQuery(
  baseOptions: useSuspenseQuery.Options<FetchSteelOrdersForPrintQueryVariables>,
) {
  return useSuspenseQuery<FetchSteelOrdersForPrintQuery, FetchSteelOrdersForPrintQueryVariables>(
    FetchSteelOrdersForPrintDocument,
    baseOptions,
  )
}

export function useFetchTenantQuery(baseOptions: useQuery.Options<FetchTenantQuery, FetchTenantQueryVariables>) {
  return useQuery<FetchTenantQuery, FetchTenantQueryVariables>(FetchTenantDocument, baseOptions)
}

export function useFetchTenantSuspenseQuery(baseOptions: useSuspenseQuery.Options<FetchTenantQueryVariables>) {
  return useSuspenseQuery<FetchTenantQuery, FetchTenantQueryVariables>(FetchTenantDocument, baseOptions)
}

export function useFetchTenantsQuery(baseOptions?: useQuery.Options<FetchTenantsQuery, FetchTenantsQueryVariables>) {
  return useQuery<FetchTenantsQuery, FetchTenantsQueryVariables>(FetchTenantsDocument, baseOptions)
}

export function useFetchTenantsSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchTenantsQueryVariables>) {
  return useSuspenseQuery<FetchTenantsQuery, FetchTenantsQueryVariables>(FetchTenantsDocument, baseOptions)
}

export function useFetchUnlinkedMillsheetsQuery(
  baseOptions?: useQuery.Options<FetchUnlinkedMillsheetsQuery, FetchUnlinkedMillsheetsQueryVariables>,
) {
  return useQuery<FetchUnlinkedMillsheetsQuery, FetchUnlinkedMillsheetsQueryVariables>(
    FetchUnlinkedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchUnlinkedMillsheetsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchUnlinkedMillsheetsQueryVariables>,
) {
  return useSuspenseQuery<FetchUnlinkedMillsheetsQuery, FetchUnlinkedMillsheetsQueryVariables>(
    FetchUnlinkedMillsheetsDocument,
    baseOptions,
  )
}

export function useFetchUnlinkedMillsheetsFilterOptionsQuery(
  baseOptions?: useQuery.Options<
    FetchUnlinkedMillsheetsFilterOptionsQuery,
    FetchUnlinkedMillsheetsFilterOptionsQueryVariables
  >,
) {
  return useQuery<FetchUnlinkedMillsheetsFilterOptionsQuery, FetchUnlinkedMillsheetsFilterOptionsQueryVariables>(
    FetchUnlinkedMillsheetsFilterOptionsDocument,
    baseOptions,
  )
}

export function useFetchUnlinkedMillsheetsFilterOptionsSuspenseQuery(
  baseOptions?: useSuspenseQuery.Options<FetchUnlinkedMillsheetsFilterOptionsQueryVariables>,
) {
  return useSuspenseQuery<
    FetchUnlinkedMillsheetsFilterOptionsQuery,
    FetchUnlinkedMillsheetsFilterOptionsQueryVariables
  >(FetchUnlinkedMillsheetsFilterOptionsDocument, baseOptions)
}

export function useFetchUsersQuery(baseOptions?: useQuery.Options<FetchUsersQuery, FetchUsersQueryVariables>) {
  return useQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, baseOptions)
}

export function useFetchUsersSuspenseQuery(baseOptions?: useSuspenseQuery.Options<FetchUsersQueryVariables>) {
  return useSuspenseQuery<FetchUsersQuery, FetchUsersQueryVariables>(FetchUsersDocument, baseOptions)
}

export function useCreateInvitationMutation(
  baseOptions?: useMutation.Options<CreateInvitationMutation, CreateInvitationMutationVariables>,
) {
  return useMutation<CreateInvitationMutation, CreateInvitationMutationVariables>(CreateInvitationDocument, baseOptions)
}

export function useAgreeToServiceTermsMutation(
  baseOptions?: useMutation.Options<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>,
) {
  return useMutation<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>(
    AgreeToServiceTermsDocument,
    baseOptions,
  )
}

export function useArchiveAdminIdentityMutation(
  baseOptions?: useMutation.Options<ArchiveAdminIdentityMutation, ArchiveAdminIdentityMutationVariables>,
) {
  return useMutation<ArchiveAdminIdentityMutation, ArchiveAdminIdentityMutationVariables>(
    ArchiveAdminIdentityDocument,
    baseOptions,
  )
}

export function useConfirmMillsheetDuplicateGroupMutation(
  baseOptions?: useMutation.Options<
    ConfirmMillsheetDuplicateGroupMutation,
    ConfirmMillsheetDuplicateGroupMutationVariables
  >,
) {
  return useMutation<ConfirmMillsheetDuplicateGroupMutation, ConfirmMillsheetDuplicateGroupMutationVariables>(
    ConfirmMillsheetDuplicateGroupDocument,
    baseOptions,
  )
}

export function useConfirmOrderMutation(
  baseOptions?: useMutation.Options<ConfirmOrderMutation, ConfirmOrderMutationVariables>,
) {
  return useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(ConfirmOrderDocument, baseOptions)
}

export function useCreateAdminIdentityInvitationMutation(
  baseOptions?: useMutation.Options<
    CreateAdminIdentityInvitationMutation,
    CreateAdminIdentityInvitationMutationVariables
  >,
) {
  return useMutation<CreateAdminIdentityInvitationMutation, CreateAdminIdentityInvitationMutationVariables>(
    CreateAdminIdentityInvitationDocument,
    baseOptions,
  )
}

export function useCreateAdminInvitationMutation(
  baseOptions?: useMutation.Options<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>,
) {
  return useMutation<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>(
    CreateAdminInvitationDocument,
    baseOptions,
  )
}

export function useCreateAdminPlanMutation(
  baseOptions?: useMutation.Options<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>,
) {
  return useMutation<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>(CreateAdminPlanDocument, baseOptions)
}

export function useCreateMillsheetsByCsvMutation(
  baseOptions?: useMutation.Options<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>,
) {
  return useMutation<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>(
    CreateMillsheetsByCsvDocument,
    baseOptions,
  )
}

export function useCreateOrderFromPdfMutation(
  baseOptions?: useMutation.Options<CreateOrderFromPdfMutation, CreateOrderFromPdfMutationVariables>,
) {
  return useMutation<CreateOrderFromPdfMutation, CreateOrderFromPdfMutationVariables>(
    CreateOrderFromPdfDocument,
    baseOptions,
  )
}

export function useCreateS3ObjectMutation(
  baseOptions?: useMutation.Options<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>,
) {
  return useMutation<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>(CreateS3ObjectDocument, baseOptions)
}

export function useCreateS3ObjectThumbnailsMutation(
  baseOptions?: useMutation.Options<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>,
) {
  return useMutation<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>(
    CreateS3ObjectThumbnailsDocument,
    baseOptions,
  )
}

export function useCreateShearingCertificatesByCsvMutation(
  baseOptions?: useMutation.Options<
    CreateShearingCertificatesByCsvMutation,
    CreateShearingCertificatesByCsvMutationVariables
  >,
) {
  return useMutation<CreateShearingCertificatesByCsvMutation, CreateShearingCertificatesByCsvMutationVariables>(
    CreateShearingCertificatesByCsvDocument,
    baseOptions,
  )
}

export function useCreateTenantMutation(
  baseOptions?: useMutation.Options<CreateTenantMutation, CreateTenantMutationVariables>,
) {
  return useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, baseOptions)
}

export function useDeleteAdminPlanMutation(
  baseOptions?: useMutation.Options<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>,
) {
  return useMutation<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>(DeleteAdminPlanDocument, baseOptions)
}

export function useDeleteAdminShapeNameConversionMutation(
  baseOptions?: useMutation.Options<
    DeleteAdminShapeNameConversionMutation,
    DeleteAdminShapeNameConversionMutationVariables
  >,
) {
  return useMutation<DeleteAdminShapeNameConversionMutation, DeleteAdminShapeNameConversionMutationVariables>(
    DeleteAdminShapeNameConversionDocument,
    baseOptions,
  )
}

export function useDeleteAdminUserMutation(
  baseOptions?: useMutation.Options<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>,
) {
  return useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(DeleteAdminUserDocument, baseOptions)
}

export function useDeleteMillsheetMutation(
  baseOptions?: useMutation.Options<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>,
) {
  return useMutation<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>(DeleteMillsheetDocument, baseOptions)
}

export function useDeleteMillsheetItemsMutation(
  baseOptions?: useMutation.Options<DeleteMillsheetItemsMutation, DeleteMillsheetItemsMutationVariables>,
) {
  return useMutation<DeleteMillsheetItemsMutation, DeleteMillsheetItemsMutationVariables>(
    DeleteMillsheetItemsDocument,
    baseOptions,
  )
}

export function useDeleteNestingDiagramMutation(
  baseOptions?: useMutation.Options<DeleteNestingDiagramMutation, DeleteNestingDiagramMutationVariables>,
) {
  return useMutation<DeleteNestingDiagramMutation, DeleteNestingDiagramMutationVariables>(
    DeleteNestingDiagramDocument,
    baseOptions,
  )
}

export function useDeleteOrderLineMatchingOrderMutation(
  baseOptions?: useMutation.Options<
    DeleteOrderLineMatchingOrderMutation,
    DeleteOrderLineMatchingOrderMutationVariables
  >,
) {
  return useMutation<DeleteOrderLineMatchingOrderMutation, DeleteOrderLineMatchingOrderMutationVariables>(
    DeleteOrderLineMatchingOrderDocument,
    baseOptions,
  )
}

export function useDeleteS3ObjectMutation(
  baseOptions?: useMutation.Options<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>,
) {
  return useMutation<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>(DeleteS3ObjectDocument, baseOptions)
}

export function useDeleteShearingCertificateMutation(
  baseOptions?: useMutation.Options<DeleteShearingCertificateMutation, DeleteShearingCertificateMutationVariables>,
) {
  return useMutation<DeleteShearingCertificateMutation, DeleteShearingCertificateMutationVariables>(
    DeleteShearingCertificateDocument,
    baseOptions,
  )
}

export function useDeleteSteelOrdersMutation(
  baseOptions?: useMutation.Options<DeleteSteelOrdersMutation, DeleteSteelOrdersMutationVariables>,
) {
  return useMutation<DeleteSteelOrdersMutation, DeleteSteelOrdersMutationVariables>(
    DeleteSteelOrdersDocument,
    baseOptions,
  )
}

export function useDeleteSteelOrdersByTargetMutation(
  baseOptions?: useMutation.Options<DeleteSteelOrdersByTargetMutation, DeleteSteelOrdersByTargetMutationVariables>,
) {
  return useMutation<DeleteSteelOrdersByTargetMutation, DeleteSteelOrdersByTargetMutationVariables>(
    DeleteSteelOrdersByTargetDocument,
    baseOptions,
  )
}

export function useDeleteTenantMutation(
  baseOptions?: useMutation.Options<DeleteTenantMutation, DeleteTenantMutationVariables>,
) {
  return useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, baseOptions)
}

export function useDeleteUserMutation(
  baseOptions?: useMutation.Options<DeleteUserMutation, DeleteUserMutationVariables>,
) {
  return useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, baseOptions)
}

export function useDetachShearingCertificatePdfMutation(
  baseOptions?: useMutation.Options<
    DetachShearingCertificatePdfMutation,
    DetachShearingCertificatePdfMutationVariables
  >,
) {
  return useMutation<DetachShearingCertificatePdfMutation, DetachShearingCertificatePdfMutationVariables>(
    DetachShearingCertificatePdfDocument,
    baseOptions,
  )
}

export function useImportAdminOrderCsvMutation(
  baseOptions?: useMutation.Options<ImportAdminOrderCsvMutation, ImportAdminOrderCsvMutationVariables>,
) {
  return useMutation<ImportAdminOrderCsvMutation, ImportAdminOrderCsvMutationVariables>(
    ImportAdminOrderCsvDocument,
    baseOptions,
  )
}

export function useImportDeliveryTableCsvMutation(
  baseOptions?: useMutation.Options<ImportDeliveryTableCsvMutation, ImportDeliveryTableCsvMutationVariables>,
) {
  return useMutation<ImportDeliveryTableCsvMutation, ImportDeliveryTableCsvMutationVariables>(
    ImportDeliveryTableCsvDocument,
    baseOptions,
  )
}

export function useImportScrmCsvMutation(
  baseOptions?: useMutation.Options<ImportScrmCsvMutation, ImportScrmCsvMutationVariables>,
) {
  return useMutation<ImportScrmCsvMutation, ImportScrmCsvMutationVariables>(ImportScrmCsvDocument, baseOptions)
}

export function usePrepareAdminOrderPdfUploadMutation(
  baseOptions?: useMutation.Options<PrepareAdminOrderPdfUploadMutation, PrepareAdminOrderPdfUploadMutationVariables>,
) {
  return useMutation<PrepareAdminOrderPdfUploadMutation, PrepareAdminOrderPdfUploadMutationVariables>(
    PrepareAdminOrderPdfUploadDocument,
    baseOptions,
  )
}

export function usePrepareOrderPdfUploadMutation(
  baseOptions?: useMutation.Options<PrepareOrderPdfUploadMutation, PrepareOrderPdfUploadMutationVariables>,
) {
  return useMutation<PrepareOrderPdfUploadMutation, PrepareOrderPdfUploadMutationVariables>(
    PrepareOrderPdfUploadDocument,
    baseOptions,
  )
}

export function usePreviewAdminOrderCsvMutation(
  baseOptions?: useMutation.Options<PreviewAdminOrderCsvMutation, PreviewAdminOrderCsvMutationVariables>,
) {
  return useMutation<PreviewAdminOrderCsvMutation, PreviewAdminOrderCsvMutationVariables>(
    PreviewAdminOrderCsvDocument,
    baseOptions,
  )
}

export function useReleaseOrderLineMatchingAllocationMutation(
  baseOptions?: useMutation.Options<
    ReleaseOrderLineMatchingAllocationMutation,
    ReleaseOrderLineMatchingAllocationMutationVariables
  >,
) {
  return useMutation<ReleaseOrderLineMatchingAllocationMutation, ReleaseOrderLineMatchingAllocationMutationVariables>(
    ReleaseOrderLineMatchingAllocationDocument,
    baseOptions,
  )
}

export function useRenameOrderProjectMutation(
  baseOptions?: useMutation.Options<RenameOrderProjectMutation, RenameOrderProjectMutationVariables>,
) {
  return useMutation<RenameOrderProjectMutation, RenameOrderProjectMutationVariables>(
    RenameOrderProjectDocument,
    baseOptions,
  )
}

export function useRestoreAdminIdentityMutation(
  baseOptions?: useMutation.Options<RestoreAdminIdentityMutation, RestoreAdminIdentityMutationVariables>,
) {
  return useMutation<RestoreAdminIdentityMutation, RestoreAdminIdentityMutationVariables>(
    RestoreAdminIdentityDocument,
    baseOptions,
  )
}

export function useRetryOrderOcrMutation(
  baseOptions?: useMutation.Options<RetryOrderOcrMutation, RetryOrderOcrMutationVariables>,
) {
  return useMutation<RetryOrderOcrMutation, RetryOrderOcrMutationVariables>(RetryOrderOcrDocument, baseOptions)
}

export function useUnconfirmMillsheetDuplicateGroupMutation(
  baseOptions?: useMutation.Options<
    UnconfirmMillsheetDuplicateGroupMutation,
    UnconfirmMillsheetDuplicateGroupMutationVariables
  >,
) {
  return useMutation<UnconfirmMillsheetDuplicateGroupMutation, UnconfirmMillsheetDuplicateGroupMutationVariables>(
    UnconfirmMillsheetDuplicateGroupDocument,
    baseOptions,
  )
}

export function useUnlinkMillsheetS3ObjectsMutation(
  baseOptions?: useMutation.Options<UnlinkMillsheetS3ObjectsMutation, UnlinkMillsheetS3ObjectsMutationVariables>,
) {
  return useMutation<UnlinkMillsheetS3ObjectsMutation, UnlinkMillsheetS3ObjectsMutationVariables>(
    UnlinkMillsheetS3ObjectsDocument,
    baseOptions,
  )
}

export function useUpdateAdminIdentityRoleMutation(
  baseOptions?: useMutation.Options<UpdateAdminIdentityRoleMutation, UpdateAdminIdentityRoleMutationVariables>,
) {
  return useMutation<UpdateAdminIdentityRoleMutation, UpdateAdminIdentityRoleMutationVariables>(
    UpdateAdminIdentityRoleDocument,
    baseOptions,
  )
}

export function useUpdateAdminPlanMutation(
  baseOptions?: useMutation.Options<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>,
) {
  return useMutation<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>(UpdateAdminPlanDocument, baseOptions)
}

export function useUpdateMillsheetMutation(
  baseOptions?: useMutation.Options<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>,
) {
  return useMutation<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>(UpdateMillsheetDocument, baseOptions)
}

export function useUpdateMillsheetItemMutation(
  baseOptions?: useMutation.Options<UpdateMillsheetItemMutation, UpdateMillsheetItemMutationVariables>,
) {
  return useMutation<UpdateMillsheetItemMutation, UpdateMillsheetItemMutationVariables>(
    UpdateMillsheetItemDocument,
    baseOptions,
  )
}

export function useUpdateMillsheetOrderNumberMutation(
  baseOptions?: useMutation.Options<UpdateMillsheetOrderNumberMutation, UpdateMillsheetOrderNumberMutationVariables>,
) {
  return useMutation<UpdateMillsheetOrderNumberMutation, UpdateMillsheetOrderNumberMutationVariables>(
    UpdateMillsheetOrderNumberDocument,
    baseOptions,
  )
}

export function useUpdateMillsheetsMutation(
  baseOptions?: useMutation.Options<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>,
) {
  return useMutation<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>(UpdateMillsheetsDocument, baseOptions)
}

export function useUpdateNestingDiagramMutation(
  baseOptions?: useMutation.Options<UpdateNestingDiagramMutation, UpdateNestingDiagramMutationVariables>,
) {
  return useMutation<UpdateNestingDiagramMutation, UpdateNestingDiagramMutationVariables>(
    UpdateNestingDiagramDocument,
    baseOptions,
  )
}

export function useUpdateOrderFromReviewMutation(
  baseOptions?: useMutation.Options<UpdateOrderFromReviewMutation, UpdateOrderFromReviewMutationVariables>,
) {
  return useMutation<UpdateOrderFromReviewMutation, UpdateOrderFromReviewMutationVariables>(
    UpdateOrderFromReviewDocument,
    baseOptions,
  )
}

export function useUpdateOrderLineMatchingItemMutation(
  baseOptions?: useMutation.Options<UpdateOrderLineMatchingItemMutation, UpdateOrderLineMatchingItemMutationVariables>,
) {
  return useMutation<UpdateOrderLineMatchingItemMutation, UpdateOrderLineMatchingItemMutationVariables>(
    UpdateOrderLineMatchingItemDocument,
    baseOptions,
  )
}

export function useUpdateS3ObjectMutation(
  baseOptions?: useMutation.Options<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>,
) {
  return useMutation<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>(UpdateS3ObjectDocument, baseOptions)
}

export function useUpdateSteelOrderItemQualityCheckStatusMutation(
  baseOptions?: useMutation.Options<
    UpdateSteelOrderItemQualityCheckStatusMutation,
    UpdateSteelOrderItemQualityCheckStatusMutationVariables
  >,
) {
  return useMutation<
    UpdateSteelOrderItemQualityCheckStatusMutation,
    UpdateSteelOrderItemQualityCheckStatusMutationVariables
  >(UpdateSteelOrderItemQualityCheckStatusDocument, baseOptions)
}

export function useUpdateSteelOrdersMutation(
  baseOptions?: useMutation.Options<UpdateSteelOrdersMutation, UpdateSteelOrdersMutationVariables>,
) {
  return useMutation<UpdateSteelOrdersMutation, UpdateSteelOrdersMutationVariables>(
    UpdateSteelOrdersDocument,
    baseOptions,
  )
}

export function useUpdateTenantMutation(
  baseOptions?: useMutation.Options<UpdateTenantMutation, UpdateTenantMutationVariables>,
) {
  return useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, baseOptions)
}

export function useUpdateTenantSettingMutation(
  baseOptions?: useMutation.Options<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>,
) {
  return useMutation<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>(
    UpdateTenantSettingDocument,
    baseOptions,
  )
}

export function useUpdateUserMutation(
  baseOptions?: useMutation.Options<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  return useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions)
}

export function useUpsertAdminShapeNameConversionMutation(
  baseOptions?: useMutation.Options<
    UpsertAdminShapeNameConversionMutation,
    UpsertAdminShapeNameConversionMutationVariables
  >,
) {
  return useMutation<UpsertAdminShapeNameConversionMutation, UpsertAdminShapeNameConversionMutationVariables>(
    UpsertAdminShapeNameConversionDocument,
    baseOptions,
  )
}

export function useUpsertAdminTenantSettingMutation(
  baseOptions?: useMutation.Options<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>,
) {
  return useMutation<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>(
    UpsertAdminTenantSettingDocument,
    baseOptions,
  )
}

export function useUpsertOrderLineMatchingAllocationMutation(
  baseOptions?: useMutation.Options<
    UpsertOrderLineMatchingAllocationMutation,
    UpsertOrderLineMatchingAllocationMutationVariables
  >,
) {
  return useMutation<UpsertOrderLineMatchingAllocationMutation, UpsertOrderLineMatchingAllocationMutationVariables>(
    UpsertOrderLineMatchingAllocationDocument,
    baseOptions,
  )
}

//
// fetchAdminS3Object
//
const fetchAdminS3Object = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchAdminS3ObjectDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchAdminShapeNameConversions
//
const fetchAdminShapeNameConversions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchAdminShapeNameConversionsQuery, FetchAdminShapeNameConversionsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchAdminShapeNameConversionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchAdminTenants
//
const fetchAdminTenants = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchAdminTenantsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchDashboard
//
const fetchDashboard = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchDashboardQuery, FetchDashboardQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchDashboardDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMe
//
const fetchMe = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchMeQuery, FetchMeQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchMeDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheetDuplicateGroupCount
//
const fetchMillsheetDuplicateGroupCount = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchMillsheetDuplicateGroupCountQuery, FetchMillsheetDuplicateGroupCountQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetDuplicateGroupCountDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheetDuplicateGroups
//
const fetchMillsheetDuplicateGroups = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchMillsheetDuplicateGroupsQuery, FetchMillsheetDuplicateGroupsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetDuplicateGroupsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheetItems
//
const fetchMillsheetItems = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetItemsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheetUniqueValues
//
const fetchMillsheetUniqueValues = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchMillsheetUniqueValuesQuery, FetchMillsheetUniqueValuesQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetUniqueValuesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheets
//
const fetchMillsheets = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMillsheetsFilterOptions
//
const fetchMillsheetsFilterOptions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchMillsheetsFilterOptionsQuery, FetchMillsheetsFilterOptionsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchMillsheetsFilterOptionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMyIdentity
//
const fetchMyIdentity = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchMyIdentityDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchMyTenantDetail
//
const fetchMyTenantDetail = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchMyTenantDetailDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchNestingDiagrams
//
const fetchNestingDiagrams = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchNestingDiagramsQuery, FetchNestingDiagramsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchNestingDiagramsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrder
//
const fetchOrder = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchOrderQuery, FetchOrderQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderLineMatchingPdfUrl
//
const fetchOrderLineMatchingPdfUrl = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchOrderLineMatchingPdfUrlQuery, FetchOrderLineMatchingPdfUrlQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderLineMatchingPdfUrlDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderLineMatchingProject
//
const fetchOrderLineMatchingProject = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchOrderLineMatchingProjectQuery, FetchOrderLineMatchingProjectQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderLineMatchingProjectDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderLineMatchingProjects
//
const fetchOrderLineMatchingProjects = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchOrderLineMatchingProjectsQuery, FetchOrderLineMatchingProjectsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderLineMatchingProjectsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderLineMatchingUnlinkedFilterOptions
//
const fetchOrderLineMatchingUnlinkedFilterOptions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<
      FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
      FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables
    >,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderLineMatchingUnlinkedFilterOptionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderLineMatchingUnlinkedItems
//
const fetchOrderLineMatchingUnlinkedItems = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<
      FetchOrderLineMatchingUnlinkedItemsQuery,
      FetchOrderLineMatchingUnlinkedItemsQueryVariables
    >,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderLineMatchingUnlinkedItemsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderOcrEnabled
//
const fetchOrderOcrEnabled = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchOrderOcrEnabledQuery, FetchOrderOcrEnabledQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderOcrEnabledDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderPdfUrl
//
const fetchOrderPdfUrl = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchOrderPdfUrlQuery, FetchOrderPdfUrlQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderPdfUrlDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrderProjectNames
//
const fetchOrderProjectNames = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchOrderProjectNamesQuery, FetchOrderProjectNamesQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrderProjectNamesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchOrders
//
const fetchOrders = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchOrdersQuery, FetchOrdersQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchOrdersDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedAdminIdentities
//
const fetchPagedAdminIdentities = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedAdminIdentitiesQuery, FetchPagedAdminIdentitiesQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedAdminIdentitiesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedMillsheetItems
//
const fetchPagedMillsheetItems = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedMillsheetItemsQuery, FetchPagedMillsheetItemsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedMillsheetItemsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedMillsheets
//
const fetchPagedMillsheets = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchPagedMillsheetsQuery, FetchPagedMillsheetsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedMillsheetsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedNestingDiagrams
//
const fetchPagedNestingDiagrams = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedNestingDiagramsQuery, FetchPagedNestingDiagramsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedNestingDiagramsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedS3Objects
//
const fetchPagedS3Objects = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchPagedS3ObjectsQuery, FetchPagedS3ObjectsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedS3ObjectsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedShearingCertificatePdfs
//
const fetchPagedShearingCertificatePdfs = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedShearingCertificatePdfsQuery, FetchPagedShearingCertificatePdfsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedShearingCertificatePdfsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedShearingCertificates
//
const fetchPagedShearingCertificates = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedShearingCertificatesQuery, FetchPagedShearingCertificatesQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedShearingCertificatesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedSteelOrderCsvImports
//
const fetchPagedSteelOrderCsvImports = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedSteelOrderCsvImportsQuery, FetchPagedSteelOrderCsvImportsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedSteelOrderCsvImportsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchPagedUnlinkedMillsheets
//
const fetchPagedUnlinkedMillsheets = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchPagedUnlinkedMillsheetsQuery, FetchPagedUnlinkedMillsheetsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchPagedUnlinkedMillsheetsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchAdminPlans
//
const fetchAdminPlans = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchAdminPlansDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchS3Objects
//
const fetchS3Objects = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchS3ObjectsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchShapeNameConversions
//
const fetchShapeNameConversions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchShapeNameConversionsQuery, FetchShapeNameConversionsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchShapeNameConversionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchShearingCertificatePdfs
//
const fetchShearingCertificatePdfs = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchShearingCertificatePdfsQuery, FetchShearingCertificatePdfsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchShearingCertificatePdfsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchShearingCertificateUniqueValues
//
const fetchShearingCertificateUniqueValues = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<
      FetchShearingCertificateUniqueValuesQuery,
      FetchShearingCertificateUniqueValuesQueryVariables
    >,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchShearingCertificateUniqueValuesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchShearingCertificates
//
const fetchShearingCertificates = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchShearingCertificatesQuery, FetchShearingCertificatesQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchShearingCertificatesDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchShearingCertificatesFilterOptions
//
const fetchShearingCertificatesFilterOptions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<
      FetchShearingCertificatesFilterOptionsQuery,
      FetchShearingCertificatesFilterOptionsQueryVariables
    >,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchShearingCertificatesFilterOptionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchSteelOrderCsvImports
//
const fetchSteelOrderCsvImports = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchSteelOrderCsvImportsQuery, FetchSteelOrderCsvImportsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchSteelOrderCsvImportsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchSteelOrderDetail
//
const fetchSteelOrderDetail = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchSteelOrderDetailQuery, FetchSteelOrderDetailQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchSteelOrderDetailDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchSteelOrders
//
const fetchSteelOrders = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchSteelOrdersQuery, FetchSteelOrdersQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchSteelOrdersDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchSteelOrdersForPrint
//
const fetchSteelOrdersForPrint = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchSteelOrdersForPrintQuery, FetchSteelOrdersForPrintQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchSteelOrdersForPrintDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchTenant
//
const fetchTenant = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchTenantQuery, FetchTenantQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchTenantDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchTenants
//
const fetchTenants = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchTenantsQuery, FetchTenantsQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchTenantsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchUnlinkedMillsheets
//
const fetchUnlinkedMillsheets = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<FetchUnlinkedMillsheetsQuery, FetchUnlinkedMillsheetsQueryVariables>,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchUnlinkedMillsheetsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchUnlinkedMillsheetsFilterOptions
//
const fetchUnlinkedMillsheetsFilterOptions = async (
  client: ApolloClient,
  options: Omit<
    ApolloClient.QueryOptions<
      FetchUnlinkedMillsheetsFilterOptionsQuery,
      FetchUnlinkedMillsheetsFilterOptionsQueryVariables
    >,
    'query'
  >,
) => {
  const result = await client.query({
    ...options,
    query: FetchUnlinkedMillsheetsFilterOptionsDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

//
// fetchUsers
//
const fetchUsers = async (
  client: ApolloClient,
  options: Omit<ApolloClient.QueryOptions<FetchUsersQuery, FetchUsersQueryVariables>, 'query'>,
) => {
  const result = await client.query({
    ...options,
    query: FetchUsersDocument,
  })
  if (result.data === undefined) {
    throw new Error('データの取得に失敗しました')
  }
  return result.data
}

const createInvitation = async (
  client: ApolloClient,
  variables: CreateInvitationMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateInvitationMutation, CreateInvitationMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateInvitationDocument,
    variables,
  })
  return result
}

const agreeToServiceTerms = async (
  client: ApolloClient,
  variables: AgreeToServiceTermsMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: AgreeToServiceTermsDocument,
    variables,
  })
  return result
}

const archiveAdminIdentity = async (
  client: ApolloClient,
  variables: ArchiveAdminIdentityMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ArchiveAdminIdentityMutation, ArchiveAdminIdentityMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ArchiveAdminIdentityDocument,
    variables,
  })
  return result
}

const confirmMillsheetDuplicateGroup = async (
  client: ApolloClient,
  variables: ConfirmMillsheetDuplicateGroupMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ConfirmMillsheetDuplicateGroupMutation, ConfirmMillsheetDuplicateGroupMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ConfirmMillsheetDuplicateGroupDocument,
    variables,
  })
  return result
}

const confirmOrder = async (
  client: ApolloClient,
  variables: ConfirmOrderMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ConfirmOrderDocument,
    variables,
  })
  return result
}

const createAdminIdentityInvitation = async (
  client: ApolloClient,
  variables: CreateAdminIdentityInvitationMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateAdminIdentityInvitationMutation, CreateAdminIdentityInvitationMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateAdminIdentityInvitationDocument,
    variables,
  })
  return result
}

const createAdminInvitation = async (
  client: ApolloClient,
  variables: CreateAdminInvitationMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateAdminInvitationDocument,
    variables,
  })
  return result
}

const createAdminPlan = async (
  client: ApolloClient,
  variables: CreateAdminPlanMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateAdminPlanDocument,
    variables,
  })
  return result
}

const createMillsheetsByCsv = async (
  client: ApolloClient,
  variables: CreateMillsheetsByCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateMillsheetsByCsvDocument,
    variables,
  })
  return result
}

const createOrderFromPdf = async (
  client: ApolloClient,
  variables: CreateOrderFromPdfMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateOrderFromPdfMutation, CreateOrderFromPdfMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateOrderFromPdfDocument,
    variables,
  })
  return result
}

const createS3Object = async (
  client: ApolloClient,
  variables: CreateS3ObjectMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateS3ObjectDocument,
    variables,
  })
  return result
}

const createS3ObjectThumbnails = async (
  client: ApolloClient,
  variables: CreateS3ObjectThumbnailsMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateS3ObjectThumbnailsDocument,
    variables,
  })
  return result
}

const createShearingCertificatesByCsv = async (
  client: ApolloClient,
  variables: CreateShearingCertificatesByCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<
      CreateShearingCertificatesByCsvMutation,
      CreateShearingCertificatesByCsvMutationVariables
    >,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateShearingCertificatesByCsvDocument,
    variables,
  })
  return result
}

const createTenant = async (
  client: ApolloClient,
  variables: CreateTenantMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<CreateTenantMutation, CreateTenantMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: CreateTenantDocument,
    variables,
  })
  return result
}

const deleteAdminPlan = async (
  client: ApolloClient,
  variables: DeleteAdminPlanMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteAdminPlanDocument,
    variables,
  })
  return result
}

const deleteAdminShapeNameConversion = async (
  client: ApolloClient,
  variables: DeleteAdminShapeNameConversionMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteAdminShapeNameConversionMutation, DeleteAdminShapeNameConversionMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteAdminShapeNameConversionDocument,
    variables,
  })
  return result
}

const deleteAdminUser = async (
  client: ApolloClient,
  variables: DeleteAdminUserMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteAdminUserDocument,
    variables,
  })
  return result
}

const deleteMillsheet = async (
  client: ApolloClient,
  variables: DeleteMillsheetMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteMillsheetDocument,
    variables,
  })
  return result
}

const deleteMillsheetItems = async (
  client: ApolloClient,
  variables: DeleteMillsheetItemsMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteMillsheetItemsMutation, DeleteMillsheetItemsMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteMillsheetItemsDocument,
    variables,
  })
  return result
}

const deleteNestingDiagram = async (
  client: ApolloClient,
  variables: DeleteNestingDiagramMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteNestingDiagramMutation, DeleteNestingDiagramMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteNestingDiagramDocument,
    variables,
  })
  return result
}

const deleteOrderLineMatchingOrder = async (
  client: ApolloClient,
  variables: DeleteOrderLineMatchingOrderMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteOrderLineMatchingOrderMutation, DeleteOrderLineMatchingOrderMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteOrderLineMatchingOrderDocument,
    variables,
  })
  return result
}

const deleteS3Object = async (
  client: ApolloClient,
  variables: DeleteS3ObjectMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteS3ObjectDocument,
    variables,
  })
  return result
}

const deleteShearingCertificate = async (
  client: ApolloClient,
  variables: DeleteShearingCertificateMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteShearingCertificateMutation, DeleteShearingCertificateMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteShearingCertificateDocument,
    variables,
  })
  return result
}

const deleteSteelOrders = async (
  client: ApolloClient,
  variables: DeleteSteelOrdersMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteSteelOrdersMutation, DeleteSteelOrdersMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteSteelOrdersDocument,
    variables,
  })
  return result
}

const deleteSteelOrdersByTarget = async (
  client: ApolloClient,
  variables: DeleteSteelOrdersByTargetMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteSteelOrdersByTargetMutation, DeleteSteelOrdersByTargetMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteSteelOrdersByTargetDocument,
    variables,
  })
  return result
}

const deleteTenant = async (
  client: ApolloClient,
  variables: DeleteTenantMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DeleteTenantMutation, DeleteTenantMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteTenantDocument,
    variables,
  })
  return result
}

const deleteUser = async (
  client: ApolloClient,
  variables: DeleteUserMutationVariables,
  options?: Omit<ApolloClient.MutateOptions<DeleteUserMutation, DeleteUserMutationVariables>, 'mutation' | 'variables'>,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DeleteUserDocument,
    variables,
  })
  return result
}

const detachShearingCertificatePdf = async (
  client: ApolloClient,
  variables: DetachShearingCertificatePdfMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<DetachShearingCertificatePdfMutation, DetachShearingCertificatePdfMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: DetachShearingCertificatePdfDocument,
    variables,
  })
  return result
}

const importAdminOrderCsv = async (
  client: ApolloClient,
  variables: ImportAdminOrderCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ImportAdminOrderCsvMutation, ImportAdminOrderCsvMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ImportAdminOrderCsvDocument,
    variables,
  })
  return result
}

const importDeliveryTableCsv = async (
  client: ApolloClient,
  variables: ImportDeliveryTableCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ImportDeliveryTableCsvMutation, ImportDeliveryTableCsvMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ImportDeliveryTableCsvDocument,
    variables,
  })
  return result
}

const importScrmCsv = async (
  client: ApolloClient,
  variables: ImportScrmCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<ImportScrmCsvMutation, ImportScrmCsvMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ImportScrmCsvDocument,
    variables,
  })
  return result
}

const prepareAdminOrderPdfUpload = async (
  client: ApolloClient,
  variables: PrepareAdminOrderPdfUploadMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<PrepareAdminOrderPdfUploadMutation, PrepareAdminOrderPdfUploadMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: PrepareAdminOrderPdfUploadDocument,
    variables,
  })
  return result
}

const prepareOrderPdfUpload = async (
  client: ApolloClient,
  variables: PrepareOrderPdfUploadMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<PrepareOrderPdfUploadMutation, PrepareOrderPdfUploadMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: PrepareOrderPdfUploadDocument,
    variables,
  })
  return result
}

const previewAdminOrderCsv = async (
  client: ApolloClient,
  variables: PreviewAdminOrderCsvMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<PreviewAdminOrderCsvMutation, PreviewAdminOrderCsvMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: PreviewAdminOrderCsvDocument,
    variables,
  })
  return result
}

const releaseOrderLineMatchingAllocation = async (
  client: ApolloClient,
  variables: ReleaseOrderLineMatchingAllocationMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<
      ReleaseOrderLineMatchingAllocationMutation,
      ReleaseOrderLineMatchingAllocationMutationVariables
    >,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: ReleaseOrderLineMatchingAllocationDocument,
    variables,
  })
  return result
}

const renameOrderProject = async (
  client: ApolloClient,
  variables: RenameOrderProjectMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<RenameOrderProjectMutation, RenameOrderProjectMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: RenameOrderProjectDocument,
    variables,
  })
  return result
}

const restoreAdminIdentity = async (
  client: ApolloClient,
  variables: RestoreAdminIdentityMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<RestoreAdminIdentityMutation, RestoreAdminIdentityMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: RestoreAdminIdentityDocument,
    variables,
  })
  return result
}

const retryOrderOcr = async (
  client: ApolloClient,
  variables: RetryOrderOcrMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<RetryOrderOcrMutation, RetryOrderOcrMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: RetryOrderOcrDocument,
    variables,
  })
  return result
}

const unconfirmMillsheetDuplicateGroup = async (
  client: ApolloClient,
  variables: UnconfirmMillsheetDuplicateGroupMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<
      UnconfirmMillsheetDuplicateGroupMutation,
      UnconfirmMillsheetDuplicateGroupMutationVariables
    >,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UnconfirmMillsheetDuplicateGroupDocument,
    variables,
  })
  return result
}

const unlinkMillsheetS3Objects = async (
  client: ApolloClient,
  variables: UnlinkMillsheetS3ObjectsMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UnlinkMillsheetS3ObjectsMutation, UnlinkMillsheetS3ObjectsMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UnlinkMillsheetS3ObjectsDocument,
    variables,
  })
  return result
}

const updateAdminIdentityRole = async (
  client: ApolloClient,
  variables: UpdateAdminIdentityRoleMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateAdminIdentityRoleMutation, UpdateAdminIdentityRoleMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateAdminIdentityRoleDocument,
    variables,
  })
  return result
}

const updateAdminPlan = async (
  client: ApolloClient,
  variables: UpdateAdminPlanMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateAdminPlanDocument,
    variables,
  })
  return result
}

const updateMillsheet = async (
  client: ApolloClient,
  variables: UpdateMillsheetMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateMillsheetDocument,
    variables,
  })
  return result
}

const updateMillsheetItem = async (
  client: ApolloClient,
  variables: UpdateMillsheetItemMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateMillsheetItemMutation, UpdateMillsheetItemMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateMillsheetItemDocument,
    variables,
  })
  return result
}

const updateMillsheetOrderNumber = async (
  client: ApolloClient,
  variables: UpdateMillsheetOrderNumberMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateMillsheetOrderNumberMutation, UpdateMillsheetOrderNumberMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateMillsheetOrderNumberDocument,
    variables,
  })
  return result
}

const updateMillsheets = async (
  client: ApolloClient,
  variables: UpdateMillsheetsMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateMillsheetsDocument,
    variables,
  })
  return result
}

const updateNestingDiagram = async (
  client: ApolloClient,
  variables: UpdateNestingDiagramMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateNestingDiagramMutation, UpdateNestingDiagramMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateNestingDiagramDocument,
    variables,
  })
  return result
}

const updateOrderFromReview = async (
  client: ApolloClient,
  variables: UpdateOrderFromReviewMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateOrderFromReviewMutation, UpdateOrderFromReviewMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateOrderFromReviewDocument,
    variables,
  })
  return result
}

const updateOrderLineMatchingItem = async (
  client: ApolloClient,
  variables: UpdateOrderLineMatchingItemMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateOrderLineMatchingItemMutation, UpdateOrderLineMatchingItemMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateOrderLineMatchingItemDocument,
    variables,
  })
  return result
}

const updateS3Object = async (
  client: ApolloClient,
  variables: UpdateS3ObjectMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateS3ObjectDocument,
    variables,
  })
  return result
}

const updateSteelOrderItemQualityCheckStatus = async (
  client: ApolloClient,
  variables: UpdateSteelOrderItemQualityCheckStatusMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<
      UpdateSteelOrderItemQualityCheckStatusMutation,
      UpdateSteelOrderItemQualityCheckStatusMutationVariables
    >,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateSteelOrderItemQualityCheckStatusDocument,
    variables,
  })
  return result
}

const updateSteelOrders = async (
  client: ApolloClient,
  variables: UpdateSteelOrdersMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateSteelOrdersMutation, UpdateSteelOrdersMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateSteelOrdersDocument,
    variables,
  })
  return result
}

const updateTenant = async (
  client: ApolloClient,
  variables: UpdateTenantMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateTenantMutation, UpdateTenantMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateTenantDocument,
    variables,
  })
  return result
}

const updateTenantSetting = async (
  client: ApolloClient,
  variables: UpdateTenantSettingMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateTenantSettingDocument,
    variables,
  })
  return result
}

const updateUser = async (
  client: ApolloClient,
  variables: UpdateUserMutationVariables,
  options?: Omit<ApolloClient.MutateOptions<UpdateUserMutation, UpdateUserMutationVariables>, 'mutation' | 'variables'>,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpdateUserDocument,
    variables,
  })
  return result
}

const upsertAdminShapeNameConversion = async (
  client: ApolloClient,
  variables: UpsertAdminShapeNameConversionMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpsertAdminShapeNameConversionMutation, UpsertAdminShapeNameConversionMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpsertAdminShapeNameConversionDocument,
    variables,
  })
  return result
}

const upsertAdminTenantSetting = async (
  client: ApolloClient,
  variables: UpsertAdminTenantSettingMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpsertAdminTenantSettingDocument,
    variables,
  })
  return result
}

const upsertOrderLineMatchingAllocation = async (
  client: ApolloClient,
  variables: UpsertOrderLineMatchingAllocationMutationVariables,
  options?: Omit<
    ApolloClient.MutateOptions<
      UpsertOrderLineMatchingAllocationMutation,
      UpsertOrderLineMatchingAllocationMutationVariables
    >,
    'mutation' | 'variables'
  >,
) => {
  const result = await client.mutate({
    ...options,
    mutation: UpsertOrderLineMatchingAllocationDocument,
    variables,
  })
  return result
}

const useClient = () => {
  const client = useApolloClient()
  return {
    fetchAdminS3Object: async (
      variables: FetchAdminS3ObjectQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchAdminS3ObjectQuery, FetchAdminS3ObjectQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchAdminS3Object(client, { ...options, variables })
    },
    fetchAdminShapeNameConversions: async (
      variables: FetchAdminShapeNameConversionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchAdminShapeNameConversionsQuery, FetchAdminShapeNameConversionsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchAdminShapeNameConversions(client, { ...options, variables })
    },
    fetchAdminTenants: async (
      variables: FetchAdminTenantsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchAdminTenantsQuery, FetchAdminTenantsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchAdminTenants(client, { ...options, variables })
    },
    fetchDashboard: async (
      variables: FetchDashboardQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchDashboardQuery, FetchDashboardQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchDashboard(client, { ...options, variables })
    },
    fetchMe: async (
      variables: FetchMeQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchMeQuery, FetchMeQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchMe(client, { ...options, variables })
    },
    fetchMillsheetDuplicateGroupCount: async (
      variables: FetchMillsheetDuplicateGroupCountQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchMillsheetDuplicateGroupCountQuery,
          FetchMillsheetDuplicateGroupCountQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheetDuplicateGroupCount(client, { ...options, variables })
    },
    fetchMillsheetDuplicateGroups: async (
      variables: FetchMillsheetDuplicateGroupsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMillsheetDuplicateGroupsQuery, FetchMillsheetDuplicateGroupsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheetDuplicateGroups(client, { ...options, variables })
    },
    fetchMillsheetItems: async (
      variables: FetchMillsheetItemsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMillsheetItemsQuery, FetchMillsheetItemsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheetItems(client, { ...options, variables })
    },
    fetchMillsheetUniqueValues: async (
      variables: FetchMillsheetUniqueValuesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMillsheetUniqueValuesQuery, FetchMillsheetUniqueValuesQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheetUniqueValues(client, { ...options, variables })
    },
    fetchMillsheets: async (
      variables: FetchMillsheetsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMillsheetsQuery, FetchMillsheetsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheets(client, { ...options, variables })
    },
    fetchMillsheetsFilterOptions: async (
      variables: FetchMillsheetsFilterOptionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMillsheetsFilterOptionsQuery, FetchMillsheetsFilterOptionsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMillsheetsFilterOptions(client, { ...options, variables })
    },
    fetchMyIdentity: async (
      variables: FetchMyIdentityQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMyIdentityQuery, FetchMyIdentityQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMyIdentity(client, { ...options, variables })
    },
    fetchMyTenantDetail: async (
      variables: FetchMyTenantDetailQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchMyTenantDetailQuery, FetchMyTenantDetailQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchMyTenantDetail(client, { ...options, variables })
    },
    fetchNestingDiagrams: async (
      variables: FetchNestingDiagramsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchNestingDiagramsQuery, FetchNestingDiagramsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchNestingDiagrams(client, { ...options, variables })
    },
    fetchOrder: async (
      variables: FetchOrderQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchOrderQuery, FetchOrderQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchOrder(client, { ...options, variables })
    },
    fetchOrderLineMatchingPdfUrl: async (
      variables: FetchOrderLineMatchingPdfUrlQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderLineMatchingPdfUrlQuery, FetchOrderLineMatchingPdfUrlQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderLineMatchingPdfUrl(client, { ...options, variables })
    },
    fetchOrderLineMatchingProject: async (
      variables: FetchOrderLineMatchingProjectQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderLineMatchingProjectQuery, FetchOrderLineMatchingProjectQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderLineMatchingProject(client, { ...options, variables })
    },
    fetchOrderLineMatchingProjects: async (
      variables: FetchOrderLineMatchingProjectsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderLineMatchingProjectsQuery, FetchOrderLineMatchingProjectsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderLineMatchingProjects(client, { ...options, variables })
    },
    fetchOrderLineMatchingUnlinkedFilterOptions: async (
      variables: FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchOrderLineMatchingUnlinkedFilterOptionsQuery,
          FetchOrderLineMatchingUnlinkedFilterOptionsQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderLineMatchingUnlinkedFilterOptions(client, { ...options, variables })
    },
    fetchOrderLineMatchingUnlinkedItems: async (
      variables: FetchOrderLineMatchingUnlinkedItemsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchOrderLineMatchingUnlinkedItemsQuery,
          FetchOrderLineMatchingUnlinkedItemsQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderLineMatchingUnlinkedItems(client, { ...options, variables })
    },
    fetchOrderOcrEnabled: async (
      variables: FetchOrderOcrEnabledQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderOcrEnabledQuery, FetchOrderOcrEnabledQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderOcrEnabled(client, { ...options, variables })
    },
    fetchOrderPdfUrl: async (
      variables: FetchOrderPdfUrlQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderPdfUrlQuery, FetchOrderPdfUrlQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderPdfUrl(client, { ...options, variables })
    },
    fetchOrderProjectNames: async (
      variables: FetchOrderProjectNamesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchOrderProjectNamesQuery, FetchOrderProjectNamesQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchOrderProjectNames(client, { ...options, variables })
    },
    fetchOrders: async (
      variables: FetchOrdersQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchOrdersQuery, FetchOrdersQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchOrders(client, { ...options, variables })
    },
    fetchPagedAdminIdentities: async (
      variables: FetchPagedAdminIdentitiesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedAdminIdentitiesQuery, FetchPagedAdminIdentitiesQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedAdminIdentities(client, { ...options, variables })
    },
    fetchPagedMillsheetItems: async (
      variables: FetchPagedMillsheetItemsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedMillsheetItemsQuery, FetchPagedMillsheetItemsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedMillsheetItems(client, { ...options, variables })
    },
    fetchPagedMillsheets: async (
      variables: FetchPagedMillsheetsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedMillsheetsQuery, FetchPagedMillsheetsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedMillsheets(client, { ...options, variables })
    },
    fetchPagedNestingDiagrams: async (
      variables: FetchPagedNestingDiagramsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedNestingDiagramsQuery, FetchPagedNestingDiagramsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedNestingDiagrams(client, { ...options, variables })
    },
    fetchPagedS3Objects: async (
      variables: FetchPagedS3ObjectsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedS3ObjectsQuery, FetchPagedS3ObjectsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedS3Objects(client, { ...options, variables })
    },
    fetchPagedShearingCertificatePdfs: async (
      variables: FetchPagedShearingCertificatePdfsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchPagedShearingCertificatePdfsQuery,
          FetchPagedShearingCertificatePdfsQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedShearingCertificatePdfs(client, { ...options, variables })
    },
    fetchPagedShearingCertificates: async (
      variables: FetchPagedShearingCertificatesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedShearingCertificatesQuery, FetchPagedShearingCertificatesQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedShearingCertificates(client, { ...options, variables })
    },
    fetchPagedSteelOrderCsvImports: async (
      variables: FetchPagedSteelOrderCsvImportsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedSteelOrderCsvImportsQuery, FetchPagedSteelOrderCsvImportsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedSteelOrderCsvImports(client, { ...options, variables })
    },
    fetchPagedUnlinkedMillsheets: async (
      variables: FetchPagedUnlinkedMillsheetsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchPagedUnlinkedMillsheetsQuery, FetchPagedUnlinkedMillsheetsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchPagedUnlinkedMillsheets(client, { ...options, variables })
    },
    fetchAdminPlans: async (
      variables: FetchAdminPlansQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchAdminPlansQuery, FetchAdminPlansQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchAdminPlans(client, { ...options, variables })
    },
    fetchS3Objects: async (
      variables: FetchS3ObjectsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchS3ObjectsQuery, FetchS3ObjectsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchS3Objects(client, { ...options, variables })
    },
    fetchShapeNameConversions: async (
      variables: FetchShapeNameConversionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchShapeNameConversionsQuery, FetchShapeNameConversionsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchShapeNameConversions(client, { ...options, variables })
    },
    fetchShearingCertificatePdfs: async (
      variables: FetchShearingCertificatePdfsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchShearingCertificatePdfsQuery, FetchShearingCertificatePdfsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchShearingCertificatePdfs(client, { ...options, variables })
    },
    fetchShearingCertificateUniqueValues: async (
      variables: FetchShearingCertificateUniqueValuesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchShearingCertificateUniqueValuesQuery,
          FetchShearingCertificateUniqueValuesQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchShearingCertificateUniqueValues(client, { ...options, variables })
    },
    fetchShearingCertificates: async (
      variables: FetchShearingCertificatesQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchShearingCertificatesQuery, FetchShearingCertificatesQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchShearingCertificates(client, { ...options, variables })
    },
    fetchShearingCertificatesFilterOptions: async (
      variables: FetchShearingCertificatesFilterOptionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchShearingCertificatesFilterOptionsQuery,
          FetchShearingCertificatesFilterOptionsQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchShearingCertificatesFilterOptions(client, { ...options, variables })
    },
    fetchSteelOrderCsvImports: async (
      variables: FetchSteelOrderCsvImportsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchSteelOrderCsvImportsQuery, FetchSteelOrderCsvImportsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchSteelOrderCsvImports(client, { ...options, variables })
    },
    fetchSteelOrderDetail: async (
      variables: FetchSteelOrderDetailQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchSteelOrderDetailQuery, FetchSteelOrderDetailQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchSteelOrderDetail(client, { ...options, variables })
    },
    fetchSteelOrders: async (
      variables: FetchSteelOrdersQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchSteelOrdersQuery, FetchSteelOrdersQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchSteelOrders(client, { ...options, variables })
    },
    fetchSteelOrdersForPrint: async (
      variables: FetchSteelOrdersForPrintQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchSteelOrdersForPrintQuery, FetchSteelOrdersForPrintQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchSteelOrdersForPrint(client, { ...options, variables })
    },
    fetchTenant: async (
      variables: FetchTenantQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchTenantQuery, FetchTenantQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchTenant(client, { ...options, variables })
    },
    fetchTenants: async (
      variables: FetchTenantsQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchTenantsQuery, FetchTenantsQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchTenants(client, { ...options, variables })
    },
    fetchUnlinkedMillsheets: async (
      variables: FetchUnlinkedMillsheetsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<FetchUnlinkedMillsheetsQuery, FetchUnlinkedMillsheetsQueryVariables>,
        'query' | 'variables'
      >,
    ) => {
      return await fetchUnlinkedMillsheets(client, { ...options, variables })
    },
    fetchUnlinkedMillsheetsFilterOptions: async (
      variables: FetchUnlinkedMillsheetsFilterOptionsQueryVariables,
      options?: Omit<
        ApolloClient.QueryOptions<
          FetchUnlinkedMillsheetsFilterOptionsQuery,
          FetchUnlinkedMillsheetsFilterOptionsQueryVariables
        >,
        'query' | 'variables'
      >,
    ) => {
      return await fetchUnlinkedMillsheetsFilterOptions(client, { ...options, variables })
    },
    fetchUsers: async (
      variables: FetchUsersQueryVariables,
      options?: Omit<ApolloClient.QueryOptions<FetchUsersQuery, FetchUsersQueryVariables>, 'query' | 'variables'>,
    ) => {
      return await fetchUsers(client, { ...options, variables })
    },
    createInvitation: async (
      variables: CreateInvitationMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateInvitationMutation, CreateInvitationMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createInvitation(client, variables, options)
    },
    agreeToServiceTerms: async (
      variables: AgreeToServiceTermsMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<AgreeToServiceTermsMutation, AgreeToServiceTermsMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await agreeToServiceTerms(client, variables, options)
    },
    archiveAdminIdentity: async (
      variables: ArchiveAdminIdentityMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<ArchiveAdminIdentityMutation, ArchiveAdminIdentityMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await archiveAdminIdentity(client, variables, options)
    },
    confirmMillsheetDuplicateGroup: async (
      variables: ConfirmMillsheetDuplicateGroupMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          ConfirmMillsheetDuplicateGroupMutation,
          ConfirmMillsheetDuplicateGroupMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await confirmMillsheetDuplicateGroup(client, variables, options)
    },
    confirmOrder: async (
      variables: ConfirmOrderMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await confirmOrder(client, variables, options)
    },
    createAdminIdentityInvitation: async (
      variables: CreateAdminIdentityInvitationMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          CreateAdminIdentityInvitationMutation,
          CreateAdminIdentityInvitationMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await createAdminIdentityInvitation(client, variables, options)
    },
    createAdminInvitation: async (
      variables: CreateAdminInvitationMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateAdminInvitationMutation, CreateAdminInvitationMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createAdminInvitation(client, variables, options)
    },
    createAdminPlan: async (
      variables: CreateAdminPlanMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateAdminPlanMutation, CreateAdminPlanMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createAdminPlan(client, variables, options)
    },
    createMillsheetsByCsv: async (
      variables: CreateMillsheetsByCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateMillsheetsByCsvMutation, CreateMillsheetsByCsvMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createMillsheetsByCsv(client, variables, options)
    },
    createOrderFromPdf: async (
      variables: CreateOrderFromPdfMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateOrderFromPdfMutation, CreateOrderFromPdfMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createOrderFromPdf(client, variables, options)
    },
    createS3Object: async (
      variables: CreateS3ObjectMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateS3ObjectMutation, CreateS3ObjectMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createS3Object(client, variables, options)
    },
    createS3ObjectThumbnails: async (
      variables: CreateS3ObjectThumbnailsMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateS3ObjectThumbnailsMutation, CreateS3ObjectThumbnailsMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createS3ObjectThumbnails(client, variables, options)
    },
    createShearingCertificatesByCsv: async (
      variables: CreateShearingCertificatesByCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          CreateShearingCertificatesByCsvMutation,
          CreateShearingCertificatesByCsvMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await createShearingCertificatesByCsv(client, variables, options)
    },
    createTenant: async (
      variables: CreateTenantMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<CreateTenantMutation, CreateTenantMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await createTenant(client, variables, options)
    },
    deleteAdminPlan: async (
      variables: DeleteAdminPlanMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteAdminPlanMutation, DeleteAdminPlanMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteAdminPlan(client, variables, options)
    },
    deleteAdminShapeNameConversion: async (
      variables: DeleteAdminShapeNameConversionMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          DeleteAdminShapeNameConversionMutation,
          DeleteAdminShapeNameConversionMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteAdminShapeNameConversion(client, variables, options)
    },
    deleteAdminUser: async (
      variables: DeleteAdminUserMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteAdminUser(client, variables, options)
    },
    deleteMillsheet: async (
      variables: DeleteMillsheetMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteMillsheetMutation, DeleteMillsheetMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteMillsheet(client, variables, options)
    },
    deleteMillsheetItems: async (
      variables: DeleteMillsheetItemsMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteMillsheetItemsMutation, DeleteMillsheetItemsMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteMillsheetItems(client, variables, options)
    },
    deleteNestingDiagram: async (
      variables: DeleteNestingDiagramMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteNestingDiagramMutation, DeleteNestingDiagramMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteNestingDiagram(client, variables, options)
    },
    deleteOrderLineMatchingOrder: async (
      variables: DeleteOrderLineMatchingOrderMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteOrderLineMatchingOrderMutation, DeleteOrderLineMatchingOrderMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteOrderLineMatchingOrder(client, variables, options)
    },
    deleteS3Object: async (
      variables: DeleteS3ObjectMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteS3ObjectMutation, DeleteS3ObjectMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteS3Object(client, variables, options)
    },
    deleteShearingCertificate: async (
      variables: DeleteShearingCertificateMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteShearingCertificateMutation, DeleteShearingCertificateMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteShearingCertificate(client, variables, options)
    },
    deleteSteelOrders: async (
      variables: DeleteSteelOrdersMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteSteelOrdersMutation, DeleteSteelOrdersMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteSteelOrders(client, variables, options)
    },
    deleteSteelOrdersByTarget: async (
      variables: DeleteSteelOrdersByTargetMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteSteelOrdersByTargetMutation, DeleteSteelOrdersByTargetMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteSteelOrdersByTarget(client, variables, options)
    },
    deleteTenant: async (
      variables: DeleteTenantMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteTenantMutation, DeleteTenantMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteTenant(client, variables, options)
    },
    deleteUser: async (
      variables: DeleteUserMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DeleteUserMutation, DeleteUserMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await deleteUser(client, variables, options)
    },
    detachShearingCertificatePdf: async (
      variables: DetachShearingCertificatePdfMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<DetachShearingCertificatePdfMutation, DetachShearingCertificatePdfMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await detachShearingCertificatePdf(client, variables, options)
    },
    importAdminOrderCsv: async (
      variables: ImportAdminOrderCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<ImportAdminOrderCsvMutation, ImportAdminOrderCsvMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await importAdminOrderCsv(client, variables, options)
    },
    importDeliveryTableCsv: async (
      variables: ImportDeliveryTableCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<ImportDeliveryTableCsvMutation, ImportDeliveryTableCsvMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await importDeliveryTableCsv(client, variables, options)
    },
    importScrmCsv: async (
      variables: ImportScrmCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<ImportScrmCsvMutation, ImportScrmCsvMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await importScrmCsv(client, variables, options)
    },
    prepareAdminOrderPdfUpload: async (
      variables: PrepareAdminOrderPdfUploadMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<PrepareAdminOrderPdfUploadMutation, PrepareAdminOrderPdfUploadMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await prepareAdminOrderPdfUpload(client, variables, options)
    },
    prepareOrderPdfUpload: async (
      variables: PrepareOrderPdfUploadMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<PrepareOrderPdfUploadMutation, PrepareOrderPdfUploadMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await prepareOrderPdfUpload(client, variables, options)
    },
    previewAdminOrderCsv: async (
      variables: PreviewAdminOrderCsvMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<PreviewAdminOrderCsvMutation, PreviewAdminOrderCsvMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await previewAdminOrderCsv(client, variables, options)
    },
    releaseOrderLineMatchingAllocation: async (
      variables: ReleaseOrderLineMatchingAllocationMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          ReleaseOrderLineMatchingAllocationMutation,
          ReleaseOrderLineMatchingAllocationMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await releaseOrderLineMatchingAllocation(client, variables, options)
    },
    renameOrderProject: async (
      variables: RenameOrderProjectMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<RenameOrderProjectMutation, RenameOrderProjectMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await renameOrderProject(client, variables, options)
    },
    restoreAdminIdentity: async (
      variables: RestoreAdminIdentityMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<RestoreAdminIdentityMutation, RestoreAdminIdentityMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await restoreAdminIdentity(client, variables, options)
    },
    retryOrderOcr: async (
      variables: RetryOrderOcrMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<RetryOrderOcrMutation, RetryOrderOcrMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await retryOrderOcr(client, variables, options)
    },
    unconfirmMillsheetDuplicateGroup: async (
      variables: UnconfirmMillsheetDuplicateGroupMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          UnconfirmMillsheetDuplicateGroupMutation,
          UnconfirmMillsheetDuplicateGroupMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await unconfirmMillsheetDuplicateGroup(client, variables, options)
    },
    unlinkMillsheetS3Objects: async (
      variables: UnlinkMillsheetS3ObjectsMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UnlinkMillsheetS3ObjectsMutation, UnlinkMillsheetS3ObjectsMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await unlinkMillsheetS3Objects(client, variables, options)
    },
    updateAdminIdentityRole: async (
      variables: UpdateAdminIdentityRoleMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateAdminIdentityRoleMutation, UpdateAdminIdentityRoleMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateAdminIdentityRole(client, variables, options)
    },
    updateAdminPlan: async (
      variables: UpdateAdminPlanMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateAdminPlanMutation, UpdateAdminPlanMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateAdminPlan(client, variables, options)
    },
    updateMillsheet: async (
      variables: UpdateMillsheetMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateMillsheetMutation, UpdateMillsheetMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateMillsheet(client, variables, options)
    },
    updateMillsheetItem: async (
      variables: UpdateMillsheetItemMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateMillsheetItemMutation, UpdateMillsheetItemMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateMillsheetItem(client, variables, options)
    },
    updateMillsheetOrderNumber: async (
      variables: UpdateMillsheetOrderNumberMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateMillsheetOrderNumberMutation, UpdateMillsheetOrderNumberMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateMillsheetOrderNumber(client, variables, options)
    },
    updateMillsheets: async (
      variables: UpdateMillsheetsMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateMillsheetsMutation, UpdateMillsheetsMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateMillsheets(client, variables, options)
    },
    updateNestingDiagram: async (
      variables: UpdateNestingDiagramMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateNestingDiagramMutation, UpdateNestingDiagramMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateNestingDiagram(client, variables, options)
    },
    updateOrderFromReview: async (
      variables: UpdateOrderFromReviewMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateOrderFromReviewMutation, UpdateOrderFromReviewMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateOrderFromReview(client, variables, options)
    },
    updateOrderLineMatchingItem: async (
      variables: UpdateOrderLineMatchingItemMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateOrderLineMatchingItemMutation, UpdateOrderLineMatchingItemMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateOrderLineMatchingItem(client, variables, options)
    },
    updateS3Object: async (
      variables: UpdateS3ObjectMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateS3ObjectMutation, UpdateS3ObjectMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateS3Object(client, variables, options)
    },
    updateSteelOrderItemQualityCheckStatus: async (
      variables: UpdateSteelOrderItemQualityCheckStatusMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          UpdateSteelOrderItemQualityCheckStatusMutation,
          UpdateSteelOrderItemQualityCheckStatusMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateSteelOrderItemQualityCheckStatus(client, variables, options)
    },
    updateSteelOrders: async (
      variables: UpdateSteelOrdersMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateSteelOrdersMutation, UpdateSteelOrdersMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateSteelOrders(client, variables, options)
    },
    updateTenant: async (
      variables: UpdateTenantMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateTenantMutation, UpdateTenantMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateTenant(client, variables, options)
    },
    updateTenantSetting: async (
      variables: UpdateTenantSettingMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateTenantSetting(client, variables, options)
    },
    updateUser: async (
      variables: UpdateUserMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpdateUserMutation, UpdateUserMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await updateUser(client, variables, options)
    },
    upsertAdminShapeNameConversion: async (
      variables: UpsertAdminShapeNameConversionMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          UpsertAdminShapeNameConversionMutation,
          UpsertAdminShapeNameConversionMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await upsertAdminShapeNameConversion(client, variables, options)
    },
    upsertAdminTenantSetting: async (
      variables: UpsertAdminTenantSettingMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<UpsertAdminTenantSettingMutation, UpsertAdminTenantSettingMutationVariables>,
        'mutation' | 'variables'
      >,
    ) => {
      return await upsertAdminTenantSetting(client, variables, options)
    },
    upsertOrderLineMatchingAllocation: async (
      variables: UpsertOrderLineMatchingAllocationMutationVariables,
      options?: Omit<
        ApolloClient.MutateOptions<
          UpsertOrderLineMatchingAllocationMutation,
          UpsertOrderLineMatchingAllocationMutationVariables
        >,
        'mutation' | 'variables'
      >,
    ) => {
      return await upsertOrderLineMatchingAllocation(client, variables, options)
    },
  }
}

export const api = {
  useClient,
  useFetchAdminS3ObjectSuspenseQuery,
  useFetchAdminShapeNameConversionsSuspenseQuery,
  useFetchAdminTenantsSuspenseQuery,
  useFetchDashboardSuspenseQuery,
  useFetchMeSuspenseQuery,
  useFetchMillsheetDuplicateGroupCountSuspenseQuery,
  useFetchMillsheetDuplicateGroupsSuspenseQuery,
  useFetchMillsheetItemsSuspenseQuery,
  useFetchMillsheetUniqueValuesSuspenseQuery,
  useFetchMillsheetsSuspenseQuery,
  useFetchMillsheetsFilterOptionsSuspenseQuery,
  useFetchMyIdentitySuspenseQuery,
  useFetchMyTenantDetailSuspenseQuery,
  useFetchNestingDiagramsSuspenseQuery,
  useFetchOrderSuspenseQuery,
  useFetchOrderLineMatchingPdfUrlSuspenseQuery,
  useFetchOrderLineMatchingProjectSuspenseQuery,
  useFetchOrderLineMatchingProjectsSuspenseQuery,
  useFetchOrderLineMatchingUnlinkedFilterOptionsSuspenseQuery,
  useFetchOrderLineMatchingUnlinkedItemsSuspenseQuery,
  useFetchOrderOcrEnabledSuspenseQuery,
  useFetchOrderPdfUrlSuspenseQuery,
  useFetchOrderProjectNamesSuspenseQuery,
  useFetchOrdersSuspenseQuery,
  useFetchPagedAdminIdentitiesSuspenseQuery,
  useFetchPagedMillsheetItemsSuspenseQuery,
  useFetchPagedMillsheetsSuspenseQuery,
  useFetchPagedNestingDiagramsSuspenseQuery,
  useFetchPagedS3ObjectsSuspenseQuery,
  useFetchPagedShearingCertificatePdfsSuspenseQuery,
  useFetchPagedShearingCertificatesSuspenseQuery,
  useFetchPagedSteelOrderCsvImportsSuspenseQuery,
  useFetchPagedUnlinkedMillsheetsSuspenseQuery,
  useFetchAdminPlansSuspenseQuery,
  useFetchS3ObjectsSuspenseQuery,
  useFetchShapeNameConversionsSuspenseQuery,
  useFetchShearingCertificatePdfsSuspenseQuery,
  useFetchShearingCertificateUniqueValuesSuspenseQuery,
  useFetchShearingCertificatesSuspenseQuery,
  useFetchShearingCertificatesFilterOptionsSuspenseQuery,
  useFetchSteelOrderCsvImportsSuspenseQuery,
  useFetchSteelOrderDetailSuspenseQuery,
  useFetchSteelOrdersSuspenseQuery,
  useFetchSteelOrdersForPrintSuspenseQuery,
  useFetchTenantSuspenseQuery,
  useFetchTenantsSuspenseQuery,
  useFetchUnlinkedMillsheetsSuspenseQuery,
  useFetchUnlinkedMillsheetsFilterOptionsSuspenseQuery,
  useFetchUsersSuspenseQuery,
  useFetchAdminS3ObjectQuery,
  useFetchAdminShapeNameConversionsQuery,
  useFetchAdminTenantsQuery,
  useFetchDashboardQuery,
  useFetchMeQuery,
  useFetchMillsheetDuplicateGroupCountQuery,
  useFetchMillsheetDuplicateGroupsQuery,
  useFetchMillsheetItemsQuery,
  useFetchMillsheetUniqueValuesQuery,
  useFetchMillsheetsQuery,
  useFetchMillsheetsFilterOptionsQuery,
  useFetchMyIdentityQuery,
  useFetchMyTenantDetailQuery,
  useFetchNestingDiagramsQuery,
  useFetchOrderQuery,
  useFetchOrderLineMatchingPdfUrlQuery,
  useFetchOrderLineMatchingProjectQuery,
  useFetchOrderLineMatchingProjectsQuery,
  useFetchOrderLineMatchingUnlinkedFilterOptionsQuery,
  useFetchOrderLineMatchingUnlinkedItemsQuery,
  useFetchOrderOcrEnabledQuery,
  useFetchOrderPdfUrlQuery,
  useFetchOrderProjectNamesQuery,
  useFetchOrdersQuery,
  useFetchPagedAdminIdentitiesQuery,
  useFetchPagedMillsheetItemsQuery,
  useFetchPagedMillsheetsQuery,
  useFetchPagedNestingDiagramsQuery,
  useFetchPagedS3ObjectsQuery,
  useFetchPagedShearingCertificatePdfsQuery,
  useFetchPagedShearingCertificatesQuery,
  useFetchPagedSteelOrderCsvImportsQuery,
  useFetchPagedUnlinkedMillsheetsQuery,
  useFetchAdminPlansQuery,
  useFetchS3ObjectsQuery,
  useFetchShapeNameConversionsQuery,
  useFetchShearingCertificatePdfsQuery,
  useFetchShearingCertificateUniqueValuesQuery,
  useFetchShearingCertificatesQuery,
  useFetchShearingCertificatesFilterOptionsQuery,
  useFetchSteelOrderCsvImportsQuery,
  useFetchSteelOrderDetailQuery,
  useFetchSteelOrdersQuery,
  useFetchSteelOrdersForPrintQuery,
  useFetchTenantQuery,
  useFetchTenantsQuery,
  useFetchUnlinkedMillsheetsQuery,
  useFetchUnlinkedMillsheetsFilterOptionsQuery,
  useFetchUsersQuery,
  useCreateInvitationMutation,
  useAgreeToServiceTermsMutation,
  useArchiveAdminIdentityMutation,
  useConfirmMillsheetDuplicateGroupMutation,
  useConfirmOrderMutation,
  useCreateAdminIdentityInvitationMutation,
  useCreateAdminInvitationMutation,
  useCreateAdminPlanMutation,
  useCreateMillsheetsByCsvMutation,
  useCreateOrderFromPdfMutation,
  useCreateS3ObjectMutation,
  useCreateS3ObjectThumbnailsMutation,
  useCreateShearingCertificatesByCsvMutation,
  useCreateTenantMutation,
  useDeleteAdminPlanMutation,
  useDeleteAdminShapeNameConversionMutation,
  useDeleteAdminUserMutation,
  useDeleteMillsheetMutation,
  useDeleteMillsheetItemsMutation,
  useDeleteNestingDiagramMutation,
  useDeleteOrderLineMatchingOrderMutation,
  useDeleteS3ObjectMutation,
  useDeleteShearingCertificateMutation,
  useDeleteSteelOrdersMutation,
  useDeleteSteelOrdersByTargetMutation,
  useDeleteTenantMutation,
  useDeleteUserMutation,
  useDetachShearingCertificatePdfMutation,
  useImportAdminOrderCsvMutation,
  useImportDeliveryTableCsvMutation,
  useImportScrmCsvMutation,
  usePrepareAdminOrderPdfUploadMutation,
  usePrepareOrderPdfUploadMutation,
  usePreviewAdminOrderCsvMutation,
  useReleaseOrderLineMatchingAllocationMutation,
  useRenameOrderProjectMutation,
  useRestoreAdminIdentityMutation,
  useRetryOrderOcrMutation,
  useUnconfirmMillsheetDuplicateGroupMutation,
  useUnlinkMillsheetS3ObjectsMutation,
  useUpdateAdminIdentityRoleMutation,
  useUpdateAdminPlanMutation,
  useUpdateMillsheetMutation,
  useUpdateMillsheetItemMutation,
  useUpdateMillsheetOrderNumberMutation,
  useUpdateMillsheetsMutation,
  useUpdateNestingDiagramMutation,
  useUpdateOrderFromReviewMutation,
  useUpdateOrderLineMatchingItemMutation,
  useUpdateS3ObjectMutation,
  useUpdateSteelOrderItemQualityCheckStatusMutation,
  useUpdateSteelOrdersMutation,
  useUpdateTenantMutation,
  useUpdateTenantSettingMutation,
  useUpdateUserMutation,
  useUpsertAdminShapeNameConversionMutation,
  useUpsertAdminTenantSettingMutation,
  useUpsertOrderLineMatchingAllocationMutation,
}

export type ApiClient = ReturnType<typeof useClient>
